//#region Imports
import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { StyleSheet, View, SafeAreaView, TouchableOpacity, useWindowDimensions, ScrollView, Platform, Linking } from 'react-native';
import { useTheme, useNavigation } from '@react-navigation/native';
import CustomLabel from '../../../components/CustomLabel/CustomLabel';
import { useAuthContext } from "../../../hooks/useAuthContext";
import { showMessage } from 'react-native-flash-message';
import CustomDropDown from '../../../components/CustomDropDown/CustomDropdown';
import CustomButton from '../../../components/CustomButton';
import CustomInput from '../../../components/CustomInput';
import TimesheetTable from './TimesheetTable';
import { Card, Checkbox } from 'react-native-paper';
import { useTranslation } from 'react-i18next';
import { useMyTimesheets } from '../../../hooks/useMyTimesheets';
import { useTableHelper } from '../../../hooks/useTableHelper';
import { ActivityIndicator } from 'react-native';
import TSExpenseTable from './TSExpenseTable';
import CustomCalendar from '../../../components/CustomCalendar/CustomCalendar';
import * as ExpoDocumentPicker from "expo-document-picker";
import Ionicons from "@react-native-vector-icons/ionicons/static";
import { Menu, MenuOptions, MenuOption, MenuTrigger, renderers } from 'react-native-popup-menu';
import Modal from "react-native-modal";
import CopyTimesheetLines from './CopyTimesheetLines';
import Swal from 'sweetalert2';
import { formatDateForUI } from '../../../constants/FormatDate';
import { TASKS, TASK_OPTIONS } from "../../../constants/Tasks";
import useRole from '../../../hooks/userRole';
import { useReports } from '../../../hooks/useReports';
import { generateUniqueID } from '../../../components/SurveyBuilderComponent/CreateSurvey/CreateSurveyFunctions';
//#endregion

const MONTHS = [
    { description: 'January', value: 1 },
    { description: 'February', value: 2 },
    { description: 'March', value: 3 },
    { description: 'April', value: 4 },
    { description: 'May', value: 5 },
    { description: 'June', value: 6 },
    { description: 'July', value: 7 },
    { description: 'August', value: 8 },
    { description: 'September', value: 9 },
    { description: 'October', value: 10 },
    { description: 'November', value: 11 },
    { description: 'December', value: 12 },
];

const MyTimesheetsDetailsScreen = (props) => {
    //#region Const Definitions
    const { t } = useTranslation();
    const { colors } = useTheme();
    const navigation = useNavigation();
    const { width, height } = useWindowDimensions();
    const styles = makeStyles(colors, width, height);
    const { hasAccess, isAdmin } = useRole();
    const { rowAdd, rowEdit, rowDelete } = useTableHelper();
    const { saveAttachments, saveExpenseLines, deleteExpenseLines,
        saveTimesheetLines, deleteTimesheetLines, saveTimesheetInfo,
        submitTimesheet, loadExpenseAttachments, deleteAttachments,
        deleteTimesheet, copyTimesheet, printTimesheet, loadPhaseCodeForClient } = useMyTimesheets();
    const { getSSRSEmbeded } = useReports();
    const [buttonStates, setButtonStates] = useState({ pressed: { 0: true } });
    const [isLoading, setIsLoading] = useState(false);
    const [displayLoading, setDisplayLoading] = useState(false);
    const [totalPressed, setTotalPressed] = useState(false);
    const [selectedWeekIndexChargeable, setSelectedWeekIndexChargeable] = useState(0);
    const [selectedWeekIndexNonChargeable, setSelectedWeekIndexNonChargeable] = useState(0);
    const [toView, setToView] = useState(false);
    const [isName, setIsName] = useState(true);
    const [ssrsUrls, setSsrsUrls] = useState([])
    const [ssrsData, setSSRSData] = useState(null)

    const [phaseCodeChargOptionsByIndex, setPhaseCodeChargOptionsByIndex] = useState([]);
    const [phaseCodeNonChargOptionsByIndex, setPhaseCodeNonChargOptionsByIndex] = useState([]);
    const [selectedChargOptions, setSelectedChargOptions] = useState({
        name: [],
        jobno: [],
        phasecode: []
    });
    const [selectedNonChargOptions, setSelectedNonChargOptions] = useState({
        name: [],
        jobno: [],
        phasecode: []
    });
    const [selectedExpOptions, setSelectedExpOptions] = useState({
        jobno: []
    });

    // Copy Timesheet variables
    const [modalCopyTSVisible, setModalCopyTSVisible] = useState(false);
    const [modalCopyTSLinesVisible, setModalCopyTSLinesVisible] = useState(false);
    const [selectedFromTimesheet, setSelectedFromTimesheet] = useState(null);
    const [modalData, setModalData] = useState(null);
    const [fromTSError, setFromTSError] = useState(false);

    // Attachments Variables
    const [attachmentsVisible, setAttachmentsVisible] = useState(false);
    const [originalAttachments, setOriginalAttachments] = useState([]);
    const [attachments, setAttachments] = useState([]);
    const [changesAttachments, setChangesAttachments] = useState([]);
    const [deletedAttachments, setDeletedAttachments] = useState([]);

    // Calendar Variables
    const [calendarVisible, setCalendarVisible] = useState(false);
    const [calendarItemIndex, setCalendarItemIndex] = useState(null);
    const [calendarSelectedData, setCalendarSelectedData] = useState({ startDate: '', endDate: '' });

    // Original data snapshots for cancel
    const [originalChargable, setOriginalChargable] = useState([]);
    const [originalNonChargable, setOriginalNonChargable] = useState([]);
    const [originalExpenses, setOriginalExpenses] = useState([]);

    // Editable data states
    const [chargable, setChargable] = useState(props.isMonthlyTimesheet ? { periodA: [], periodB: [] } : []);
    const [nonChargable, setNonChargable] = useState([]);
    const [expenses, setExpenses] = useState([]);

    // Changes and deleted items tracking
    const [changesChargable, setChangesChargable] = useState({});
    const [deletedChargable, setDeletedChargable] = useState([]);
    const refChargable = useRef(null);

    const [changesNonChargable, setChangesNonChargable] = useState({});
    const [deletedNonChargable, setDeletedNonChargable] = useState([]);
    const refNonChargable = useRef(null);

    const [changesExpenses, setChangesExpenses] = useState({});
    const [deletedExpenses, setDeletedExpenses] = useState([]);
    const refExpenses = useRef(null);

    //#region Copy Timesheet Modal
    // *TODO*
    const copyTS = (toTS, fromTS, onlyLines) => {
        const obj = {
            toTimesheet: toTS,
            fromTimesheet: fromTS,
            onlyLines: onlyLines,
        };

        copyTimesheet(obj)
            .then((res) => {
                if (res === 200) {
                    showMessage({
                        message: t("common:copyTSSuccess"),
                        type: "success",
                        duration: 3000,
                    });
                    props.loadTimesheetDetails(props.tsUI);
                } else {
                    showMessage({
                        message: t("common:errorcopy"),
                        type: "danger",
                        duration: 3000,
                    });
                }
            })
            .catch((error) => {
                showMessage({
                    message: t("common:errorcopy"),
                    type: "danger",
                    duration: 3000,
                });
            })
    }

    // *TODO*
    const renderCopyTimesheetModal = () => {
        const currentTs = props.tsInfo[0];
        const toTS = props.tsUI
        const toTimesheetName = currentTs
            ? `${new Date(currentTs.year, currentTs.month - 1).toLocaleString('default', { month: 'long' })} ${currentTs.year} Period ${currentTs.period}`
            : '';

        const timesheetOptions = props.userTimesheetsList.map(ts => {
            const monthObj = MONTHS.find(m => m.value === ts.month);
            const monthName = monthObj ? monthObj.description : '';
            return {
                label: `${monthName} ${ts.year} Period ${ts.period}`,
                value: ts.tsnoUI
            };
        });

        return (
            <View style={{ padding: 20 }}>
                <View style={{ paddingVertical: 20, alignItems: 'center' }} >
                    <CustomLabel value={t('common:copyTimesheet')} type="TITLE" />
                </View>
                {/* From timsheet */}
                <View style={{ flexDirection: 'row', paddingVertical: 10 }}>
                    <View style={{ alignItems: 'flex-start', marginHorizontal: 20 }}>
                        <CustomLabel value={t('common:fromTimesheet') + ':'} type="SUBTITLE" />
                    </View>
                    <CustomDropDown
                        options={timesheetOptions}
                        defValue={selectedFromTimesheet}
                        value={selectedFromTimesheet}
                        setValue={setSelectedFromTimesheet}
                        type={fromTSError ? "ERROR" : "MYPROFILE"}
                    />
                </View>
                {/* To timesheet */}
                <View style={{ flexDirection: 'row', paddingVertical: 10 }}>
                    <View style={{ alignItems: 'flex-start', marginHorizontal: 20 }}>
                        <CustomLabel value={t('common:toTimesheet') + ':  '} type="SUBTITLE" />
                    </View>
                    <View style={{ alignItems: 'flex-start', padding: 10, }}>
                        <CustomLabel value={toTimesheetName} type="SUBTITLE" />
                    </View>
                </View>
                {/* Copy & Cancel Buttons */}
                <View style={{ flexDirection: 'row', justifyContent: 'center', paddingHorizontal: 50 }}>
                    <CustomButton
                        text={t('common:copy')}
                        onPress={() => {
                            if (!selectedFromTimesheet) {
                                setFromTSError(true);
                                return;
                            }
                            setFromTSError(false);
                            copyTS(toTS, selectedFromTimesheet, 1);
                            setModalCopyTSVisible(false);
                        }}
                        type="BUTTON_SAVE"
                        textTop='0'
                        sz={15}
                    />
                    <CustomButton
                        text={t('common:cancel')}
                        onPress={() => setModalCopyTSVisible(false)}
                        type="BUTTON_CANCEL"
                        textTop="0"
                        sz={15}
                    />
                </View>
            </View>
        );
    };
    //#endregion

    //#region Attachments Handler
    // Handler to upload documents
    const handleUploadDocuments = useCallback(async () => {
        const maxSize = 30 * 1048576;
        let file = null;
        let uri = null;
        let type = null;
        let name = "";
        let ext = null;

        try {
            let result = await ExpoDocumentPicker.getDocumentAsync({
                type: [
                    "image/jpeg",
                    "image/gif",
                    "image/png",
                    "application/pdf",
                    "application/msword",
                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                    "application/vnd.ms-excel",
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                ],
                copyToCacheDirectory: false,
                multiple: false,
            });

            if (!result.canceled) {
                file = result.output[0];
                type = result.assets[0].mimeType;
                uri = result.assets[0].uri.split(";base64,")[1];
                name = file.name;
                ext = name.includes('.') ? name.split('.').pop().toLowerCase() : '';
            } else {
                return;
            };

            // if size allowed
            if (file.size < maxSize) {
                // Add new attachment to attachments state and changes
                const newAttachment = {
                    rowguid: generateUniqueID(),
                    tsnoui: props.tsUI || '',
                    fileName: name,
                    fileType: ext,
                    fileData: uri,
                };

                setAttachments(prev => [...prev, newAttachment]);
                setChangesAttachments(prev => [...prev, newAttachment]);
            } else {
                // file is too large
                showMessage({
                    message: t('common:errFile'),
                    type: "warning",
                    duration: 3000,
                });
            };
        } catch (error) {
            console.error(error);
        };
    }, []);

    // Remove attachment handler
    const removeAttachment = useCallback((index) => {
        setAttachments(prev => {
            const removed = prev[index];
            if (removed && removed.rowGuid) {
                // Add to deletedAttachments if it exists in backend
                setDeletedAttachments(prevDeleted => [...prevDeleted, removed.rowGuid]);
            }
            setChangesAttachments(prevChanges => prevChanges.filter(att => att.rowGuid !== removed.rowGuid));
            return prev.filter((_, i) => i !== index);
        });
    }, []);

    // Open Attachment handler
    const openAttachment = async (index, item) => {
        const newWindow = window.open('', '_blank');
        if (!newWindow) {
            alert('Popup blocked. Please allow popups for this site.');
            return;
        };
        let base64Data = item.fileData;
        let type = item.fileType.toLowerCase();
        let style = '';

        if (type === 'pdf') {
            type = 'application/pdf';
            style = 'width: 100%; height: 100%; display: block;';
        } else if (['png', 'jpg', 'jpeg', 'gif'].includes(type)) {
            type = `image/${type}`;
            style = 'display: block; max-width: 100%; height: auto;';
        } else {
            // fallback MIME type
            type = 'application/octet-stream';
            style = 'display: block; max-width: 100%; height: auto;';
        }

        const uri = `data:${type};base64,${base64Data}`;

        newWindow.document.write(`
            <html>
            <head>
                <title>${item.fileName || item.name || 'file_' + index}</title>
                <style>
                embed { ${style} }
                </style>
            </head>
            <body style="margin:0">
                <embed src="${uri}" type="${type}" />
            </body>
            </html>
        `);
        newWindow.document.close();
    };

    // Download Attachment Handler
    const downloadAttachment = useCallback(async (index, item) => {
        let downloadName = '';
        const fileName = item.fileName;
        const fileType = item.fileType?.toLowerCase();
        if (fileName?.toLowerCase().endsWith(`.${fileType}`)) {
            downloadName = fileName;
        } else {
            downloadName = `${fileName || item.name || 'file_' + index}.${fileType}`;
        };

        const mimeType = fileType ? `application/${fileType}` : 'application/octet-stream';

        // create blob
        const blobData = await fetch(`data:plain/text;base64,${item.fileData}`).then(res => {
            return res.blob();
        });
        // create download link
        const url = URL.createObjectURL(blobData);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', downloadName);

        // insert link on page
        document.body.appendChild(link);

        // start download
        link.click();

        // remove link
        link.remove();

        URL.revokeObjectURL(url);
    }, []);


    const CreateDivider = () => {
        return (
            <View
                style={{
                    borderBottomColor: '#000000',
                    borderBottomWidth: StyleSheet.hairlineWidth,
                }}
            />
        );
    };
    //#endregion

    //#region Side menu options
    const SIDE_MENU_OPTIONS = [
        { key: 'info', label: t("common:TSinfo") },
        { key: 'chargeable', label: t("common:TSchargable") },
        { key: 'nonChargeable', label: t("common:TSleavesHolidays") }, //t("common:TSnonchargable")
        { key: 'outOfPocket', label: t("common:TSOutOfPocket") },
    ]

    const handleSideMenuPress = useCallback((index) => {
        setButtonStates(prevState => {
            const newPressedState = Object.keys(prevState.pressed).reduce((acc, key) => {
                acc[key] = false;
                return acc;
            }, {});
            newPressedState[index] = true;
            return { ...prevState, pressed: newPressedState };
        });
    }, []);

    const handleTotalPress = () => {
        setTotalPressed(prev => !prev);
    };
    //#endregion

    //#region Calendar
    const getValidDateOrToday = (dateStr) => {
        if (!dateStr) return new Date().toISOString().split('T')[0];
        const dateOnly = dateStr.split('T')[0];
        const isoDateRegex = /^\d{4}-\d{2}-\d{2}$/;
        if (isoDateRegex.test(dateOnly)) {
            return dateOnly;
        }
        return new Date().toISOString().split('T')[0];
    };

    const openCalendarForItem = (index, currentDate) => {
        const validDate = getValidDateOrToday(currentDate);
        setCalendarItemIndex(index);
        setCalendarSelectedData({ startDate: validDate, endDate: validDate });
        setCalendarVisible(true);
    };

    const closeCalendar = () => {
        setCalendarVisible(false);
        setCalendarItemIndex(null);
    };

    const onCalendarDateChange = (newDates) => {
        setCalendarSelectedData(newDates);
        if (calendarItemIndex !== null) {
            const tsYear = props.tsInfo[0]?.year;
            const tsMonth = props.tsInfo[0]?.month;
            const tsPeriod = props.tsInfo[0]?.period;

            const selectedDate = new Date(newDates.startDate);
            const startDay = tsPeriod === 'A' ? 1 : 16;
            const daysInMonth = new Date(tsYear, tsMonth, 0).getDate();
            const periodStartDate = new Date(tsYear, tsMonth - 1, startDay);
            const periodEndDate = new Date(tsYear, tsMonth - 1, Math.min(startDay + 15, daysInMonth));

            // Check if selectedDate is within periodStartDate and periodEndDate inclusive
            if (props.isWeekly) {
                if (selectedDate < new Date(props.tsInfo[0].weekStart) || selectedDate > new Date(props.tsInfo[0].weekEnd)) {
                    showMessage({
                        message: t('common:dateOutOfRange'),
                        type: 'danger',
                        duration: 3000,
                    });
                    closeCalendar();
                    return;
                }
            } else {
                if (selectedDate < periodStartDate || selectedDate > periodEndDate) {
                    showMessage({
                        message: t('common:dateOutOfRange'),
                        type: 'danger',
                        duration: 3000,
                    });
                    closeCalendar();
                    return;
                }
            }

            handleEditPressExpense(calendarItemIndex, expenses[calendarItemIndex], 'doe', newDates.startDate);
        }
        closeCalendar();
    };
    //#endregion

    //#region Get Dates
    // Returns array of Date objects for the 16 days of the period
    const getPeriodDates = (year, month, period) => {
        const startDay = period === 'A' ? 1 : 16;
        const dates = [];
        const daysInMonth = new Date(year, month, 0).getDate();
        for (let i = 0; i < 16; i++) {
            const day = startDay + i;
            if (day > daysInMonth) {
                dates.push(null); // no date for this slot
            } else {
                // Create a valid Date object
                dates.push(new Date(year, month - 1, day));
            }
        }
        return dates;
    };

    const getMonthDates = (year, month) => {
        const dates = [];
        const startDay = parseInt(props.startDate);
        const endDay = parseInt(props.endDate);

        // Start from the 21st of current month
        let currentDate = new Date(year, month - 1, startDay);

        // Add dates until we reach the 20th of next month
        while (true) {
            dates.push(new Date(currentDate));
            // Check if we've reached the 20th
            if (currentDate.getDate() === endDay) {
                break;
            }
            // Move to next day
            currentDate.setDate(currentDate.getDate() + 1);
        }

        return dates;
    };

    const getPeriodFromWeekIndex = (weekIndex) => {
        const allDates = getMonthDates(props.tsInfo[0].periodA[0].year, props.tsInfo[0].periodA[0].month);
        const selectedWeek = weeks[weekIndex];
        if (!selectedWeek || selectedWeek.length === 0) return 'A';

        const firstDateOfWeek = selectedWeek[0];
        const dateIndex = allDates.findIndex(d =>
            d.getDate() === firstDateOfWeek.getDate() &&
            d.getMonth() === firstDateOfWeek.getMonth()
        );

        return dateIndex < 16 ? 'A' : 'B';
    };

    const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

    const formatDateLabel = (date) => {
        if (!date) return ''; // empty for null dates
        const dayName = dayNames[date.getDay()] || '';
        const day = date.getDate().toString().padStart(2, '0');
        return `${dayName} ${day}`;
    };

    // Helper to get weeks from 16-day period (Monday-Sunday)
    const getWeeksFromPeriod = (dates) => {
        const weeks = [];

        if (props.isWeekly) {
            // Weekly: single week from weekStart to weekEnd
            const filteredDates = dates.filter(date => date);
            if (filteredDates.length > 0) {
                weeks.push(filteredDates);
            }
            return weeks;
        } else if (props.isMonthlyTimesheet) {
            // Monthly: split weeks at period boundaries
            const startDay = parseInt(props.startDate);
            const endDay = parseInt(props.endDate);
            const daysInMonth = new Date(props.tsInfo[0].periodA[0].year, props.tsInfo[0].periodA[0].month, 0).getDate();

            // Calculate Period A end day
            const periodAEndDay = startDay + 15;

            // Find the index where Period A ends
            const periodAEndIndex = dates.findIndex(d =>
                d && d.getDate() === (periodAEndDay > daysInMonth ? periodAEndDay - daysInMonth : periodAEndDay) &&
                d.getMonth() === (periodAEndDay > daysInMonth ?
                    (props.tsInfo[0].periodB[0].month % 12) :
                    (props.tsInfo[0].periodA[0].month - 1))
            );

            let currentWeek = [];
            const filteredDates = dates.filter(date => date);

            filteredDates.forEach((date, idx) => {
                currentWeek.push(date);

                // Check if this is the last day of Period A or a Sunday
                const isPeriodAEnd = idx === periodAEndIndex;
                const isSunday = date.getDay() === 0;
                const isLastDate = idx === filteredDates.length - 1;

                if (isPeriodAEnd || isSunday || isLastDate) {
                    weeks.push(currentWeek);
                    currentWeek = [];
                }
            });

            return weeks;
        } else {
            // Period timesheet: original logic (Monday-Sunday)
            let currentWeek = [];
            const filteredDates = dates.filter(date => date);

            filteredDates.forEach((date, idx) => {
                currentWeek.push(date);
                if (date.getDay() === 0 || idx === filteredDates.length - 1) {
                    weeks.push(currentWeek);
                    currentWeek = [];
                }
            });

            return weeks;
        }
    };

    const dates = useMemo(() => {
        if (props.tsInfo[0] && props.tsInfo.length > 0) {
            if (props.isWeekly) {
                // For weekly: create array of dates from weekStart to weekEnd
                const weekDates = [];
                let currentDate = new Date(props.tsInfo[0].weekStart);
                const endDate = new Date(props.tsInfo[0].weekEnd);

                while (currentDate <= endDate) {
                    weekDates.push(new Date(currentDate));
                    currentDate.setDate(currentDate.getDate() + 1);
                }

                return weekDates;
            } else if (props.isMonthlyTimesheet) {
                return getMonthDates(props.tsInfo[0].periodA[0].year, props.tsInfo[0].periodB[0].month)
            }
            return getPeriodDates(props.tsInfo[0].year, props.tsInfo[0].month, props.tsInfo[0].period);
        }

        return [];
    }, [props.tsInfo[0]]);

    const weeks = useMemo(() => {
        if (props.tsInfo[0] && props.tsInfo.length > 0) {
            return getWeeksFromPeriod(dates)
        }
    }, [dates, props.tsInfo[0]]);
    //#endregion

    //#region CalculateTotals
    const getInitialValues = (dates) => {
        const standardUnits = [];
        const overtime = [];
        const payableOvertime = new Array(16).fill(0);

        dates.forEach((date, index) => {
            if (date) {
                const dayKey = `d${index + 1}`;
                // Get the standard unit from props.timeScheme
                const standardValue = props.timeScheme && props.timeScheme[dayKey] !== undefined ? props.timeScheme[dayKey] : 0;
                standardUnits.push(standardValue);

                const day = date.getDay();
                if (day >= 1 && day <= 4) { // Mon-Thu
                    overtime.push(-standardValue);
                } else if (day === 5) { // Fri
                    overtime.push(-standardValue);
                } else { // Sat, Sun
                    overtime.push(0);
                }
            } else {
                // For null dates, push 0
                standardUnits.push(0);
                overtime.push(0);
            }
        });

        // Calculate payableOvertime based on inCash and overtime values
        const targetLength = standardUnits.length;
        if (payableOvertime.length > targetLength) {
            payableOvertime.splice(targetLength);
        }
        return { standardUnits, overtime, payableOvertime };
    };

    const getInitialValuesMonthly = (dates) => {
        const standardUnits = [];
        const overtime = [];
        const payableOvertime = new Array(dates.length).fill(0);
        const daysInMonth = new Date(props.tsInfo[0].periodB[0].year, props.tsInfo[0].periodB[0].month, 0).getDate();
        let startDate = parseInt(props.startDate);

        dates.forEach((date, index) => {
            if (date) {
                const dateDay = date.getDate();
                let standardValue = 0;

                // Calculate the day label based on the date
                let dayKey;
                if (dateDay >= startDate) {
                    dayKey = `d${String(dateDay - (startDate - 1))}`;
                    standardValue = props.timeScheme.periodA && props.timeScheme.periodA[0][dayKey] !== undefined ? props.timeScheme.periodA[0][dayKey] : 0;
                } else {
                    let periodALeftDays = (15 - (daysInMonth - startDate))
                    if (dateDay <= periodALeftDays) {
                        dayKey = `d${String(dateDay + (16 - periodALeftDays))}`;
                        standardValue = props.timeScheme.periodA && props.timeScheme.periodA[0][dayKey] !== undefined ? props.timeScheme.periodA[0][dayKey] : 0;
                    } else {
                        dayKey = `d${String(dateDay - (periodALeftDays))}`;
                        standardValue = props.timeScheme.periodB && props.timeScheme.periodB[0][dayKey] !== undefined ? props.timeScheme.periodB[0][dayKey] : 0;
                    }
                }
                const day = date.getDay();
                standardUnits.push(standardValue);

                if (day >= 1 && day <= 4) { // Mon-Thu
                    overtime.push(-standardValue);
                } else if (day === 5) { // Fri
                    overtime.push(-standardValue);
                } else { // Sat, Sun
                    overtime.push(0);
                }
            } else {
                // For null dates, push 0
                standardUnits.push(0);
                overtime.push(0);
            }
        });

        // Calculate payableOvertime based on inCash and overtime values
        const targetLength = standardUnits.length;
        if (payableOvertime.length > targetLength) {
            payableOvertime.splice(targetLength);
        }
        return { standardUnits, overtime, payableOvertime };
    };

    // Calculating total hours for each day from all chargable and non-chargable entries
    const calculateTotals = () => {
        const totals = {};

        if (props.isWeekly) {
            // For weekly: calculate totals for 7 days (d1 to d7)
            // dates variable contains the 7 days from weekStart to weekEnd
            const weekDays = dates.filter(date => date); // Filter out any null dates

            for (let i = 1; i <= weekDays.length; i++) {
                const dayKey = `d${i}`;
                let sum = 0;

                // Sum from chargable array
                (chargable || []).forEach(item => {
                    const val = parseFloat(item[dayKey], 10);
                    if (!isNaN(val)) sum += val;
                });

                // Sum from non-chargable array
                (nonChargable || []).forEach(item => {
                    const val = parseFloat(item[dayKey], 10);
                    if (!isNaN(val)) sum += val;
                });

                totals[dayKey] = sum;
            }
        } else if (props.isMonthlyTimesheet) {
            // Get all dates to know the actual calendar days
            const allDates = getMonthDates(props.tsInfo[0].periodA[0].year, props.tsInfo[0].periodB[0].month);
            const startDay = parseInt(props.startDate);
            const endDay = parseInt(props.endDate);
            const daysInMonth = new Date(props.tsInfo[0].periodB[0].year, props.tsInfo[0].periodB[0].month, 0).getDate();

            // Calculate Period A end day
            const periodAEndDay = startDay + 15;

            allDates.forEach((date, index) => {
                const calendarDay = date.getDate();
                let sum = 0;

                // Determine which period this day belongs to and which d-key to use
                let dayKeyToUse = '';
                let dataSource = null;

                if (calendarDay >= startDay) {
                    // Period A: 21st onwards in current month
                    dayKeyToUse = `d${calendarDay - startDay + 1}`;
                    dataSource = chargable.periodA || [];
                } else if (calendarDay < 16 - (daysInMonth - startDay)) {
                    // Period A: 1st until 16 days of period are done
                    dayKeyToUse = `d${calendarDay + (daysInMonth - startDay) + 1}`;
                    dataSource = chargable.periodA || [];
                } else {
                    // Period B: days in next month (until 20th)
                    // Calculate which day of Period B this is
                    const dayInPeriodB = calendarDay - (16 - (daysInMonth - startDay)) + 1;
                    dayKeyToUse = `d${dayInPeriodB}`;
                    dataSource = chargable.periodB || [];
                }

                // Sum chargable for this day
                dataSource.forEach(item => {
                    const val = parseFloat(item[dayKeyToUse], 10);
                    if (!isNaN(val)) sum += val;
                });

                // Sum non-chargable for this day
                const nonChargableSource = calendarDay >= startDay
                    ? (nonChargable.periodA || [])
                    : (nonChargable.periodB || []);

                nonChargableSource.forEach(item => {
                    const val = parseFloat(item[dayKeyToUse], 10);
                    if (!isNaN(val)) sum += val;
                });

                totals[`d${index + 1}`] = sum;
            });
        } else {
            // period timesheets: calculate for 16 days
            for (let i = 1; i <= 16; i++) {
                const dayKey = `d${i}`;
                let sum = 0;

                chargable.forEach(item => {
                    const val = parseFloat(item[dayKey], 10);
                    if (!isNaN(val)) sum += val;
                });

                nonChargable.forEach(item => {
                    const val = parseFloat(item[dayKey], 10);
                    if (!isNaN(val)) sum += val;
                });

                totals[dayKey] = sum;
            }
        }

        return totals;
    };

    const totals = useMemo(() => {
        if (props.tsInfo[0] && props.tsInfo.length > 0) {
            return calculateTotals()
        }
    }, [chargable, nonChargable, props.tsInfo[0], props.isMonthlyTimesheet, props.isWeekly, dates]);


    //#region TotalCont
    const renderTotalsContainer = () => {
        let dates = [];
        const tsInfoToCheck = props.isMonthlyTimesheet ? props.tsInfo[0].periodA[0] : props.tsInfo[0];
        const showOvertime = tsInfoToCheck.inCash || tsInfoToCheck.inTimeOff;

        if (props.isWeekly) {
            let currentDate = new Date(props.tsInfo[0].weekStart);
            const endDate = new Date(props.tsInfo[0].weekEnd);

            while (currentDate <= endDate) {
                dates.push(new Date(currentDate));
                currentDate.setDate(currentDate.getDate() + 1);
            }
        } else if (props.isMonthlyTimesheet) {
            dates = getMonthDates(props.tsInfo[0].periodA[0].year, props.tsInfo[0].periodB[0].month);
        } else {
            dates = getPeriodDates(props.tsInfo[0].year, props.tsInfo[0].month, props.tsInfo[0].period);
        }

        const { standardUnits, overtime, payableOvertime } = props.isWeekly
            ? getInitialValues(dates)
            : (props.isMonthlyTimesheet ? getInitialValuesMonthly(dates) : getInitialValues(dates));
        const timesheetTotals = [];

        const maxDays = props.isWeekly ? 7 : (props.isMonthlyTimesheet ? dates.length : 16);
        for (let i = 1; i <= maxDays; i++) {
            timesheetTotals.push(totals[`d${i}`] || 0);
        }

        const targetLength = standardUnits.length;
        if (timesheetTotals.length > targetLength) {
            timesheetTotals.splice(targetLength);
        }

        // Adjust overtime by adding timesheet totals
        const adjustedOvertime = overtime.map((otVal, idx) => timesheetTotals[idx] + (otVal));
        const nonChargableList = props.isMonthlyTimesheet ? [...(nonChargable.periodA || []), ...(nonChargable.periodB || [])] : nonChargable;

        // Calculate payableOvertime based on inCash and overtime values
        for (let i = 0; i < timesheetTotals.length; i++) {
            const tsInfoToCheck = props.isMonthlyTimesheet ? props.tsInfo[0].periodA[0] : props.tsInfo[0];
            if (tsInfoToCheck.inCash && adjustedOvertime[i] > 0) {
                if (nonChargableList.length > 0) {
                    const dayKey = `d${i + 1}`;
                    let sum = 0;
                    nonChargableList.forEach(item => {
                        const val = parseFloat(item[dayKey], 10);
                        if (!isNaN(val)) sum += val;
                    });
                    let diff = adjustedOvertime[i] - sum;
                    if (diff > 0) payableOvertime[i] = diff;
                } else {
                    payableOvertime[i] = adjustedOvertime[i];
                }
            }
        }

        if (payableOvertime.length > targetLength) {
            payableOvertime.splice(targetLength);
        }

        const renderHeader = () => (
            <SafeAreaView style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 10 }}>
                <SafeAreaView style={{ width: '15%', minWidth: 100, justifyContent: 'center' }}>
                    <CustomLabel value="" type='SUBTITLE' />
                </SafeAreaView>
                {dates.filter(date => date).map((date, i) => (
                    <SafeAreaView key={`header-${i}`} style={{ width: '5%', minWidth: 50, alignItems: 'center' }}>
                        <CustomLabel value={formatDateLabel(date)} type='SUBTITLE' />
                    </SafeAreaView>
                ))}
                <SafeAreaView style={{ width: '5%', minWidth: 50, alignItems: 'center' }}>
                    <CustomLabel value={t('common:sum')} type='SUBTITLE' />
                </SafeAreaView>
            </SafeAreaView>
        );

        const renderRow = (label, values) => {
            const sum = values.reduce((acc, val) => acc + val, 0);
            return (
                <SafeAreaView style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 6 }}>
                    {/* Label */}
                    <SafeAreaView style={{ width: '15%', minWidth: 100, justifyContent: 'center' }}>
                        <CustomLabel value={label} type='SUBTITLE' style={{ fontWeight: 'bold' }} />
                    </SafeAreaView>
                    {/* Values d1-dN */}
                    {values.map((val, i) => (
                        <SafeAreaView key={`val-${i}`} style={{ width: '5%', minWidth: 50, alignItems: 'center' }}>
                            <CustomLabel value={val.toString()} type='SUBTITLE' />
                        </SafeAreaView>
                    ))}
                    {/* Sum */}
                    <SafeAreaView style={{ width: '5%', minWidth: 50, alignItems: 'center' }}>
                        <CustomLabel value={sum.toString()} type='SUBTITLE' style={{ fontWeight: 'bold' }} />
                    </SafeAreaView>
                </SafeAreaView>
            );
        };

        const rows = [
            { label: t('common:total'), values: timesheetTotals },
            { label: t('common:standardUnits'), values: standardUnits },
            ...(showOvertime ? [{ label: t('common:overtime'), values: adjustedOvertime }] : []),
            ...(showOvertime ? [{ label: t('common:payableOvertime'), values: payableOvertime }] : []),
        ]

        return (
            <Card style={[styles.totalCard, { marginBottom: 10 }]}>
                <Card.Content>
                    {props.isMonthlyTimesheet && <ScrollView horizontal showsHorizontalScrollIndicator={true}>
                        <SafeAreaView>
                            {renderHeader()}
                            {rows.map((row, index) => (
                                <React.Fragment key={row.label}>
                                    {renderRow(row.label, row.values)}
                                    <View style={[styles.horizontalLine]} />
                                </React.Fragment>
                            ))}
                        </SafeAreaView>
                    </ScrollView>}
                    {!props.isMonthlyTimesheet && <View>
                        <SafeAreaView>
                            {renderHeader()}
                            {rows.map((row, index) => (
                                <React.Fragment key={row.label}>
                                    {renderRow(row.label, row.values)}
                                    <View style={[styles.horizontalLine]} />
                                </React.Fragment>
                            ))}
                        </SafeAreaView>
                    </View>}
                </Card.Content>
            </Card>
        );
    };
    //#endregion

    //#region Use Effect
    useEffect(
        () => {
            // * No need to do anything here
        },
        [width, height]
    );

    // Load initial data and keep original snapshots
    useEffect(() => {
        setChangesChargable(props.isMonthlyTimesheet ? { periodA: {}, periodB: {} } : {});
        setChangesNonChargable(props.isMonthlyTimesheet ? { periodA: {}, periodB: {} } : {});
        setIsLoading(true);
        setChargable(props.timesheetChargableList || []);
        setOriginalChargable(props.timesheetChargableList || []);
        setNonChargable(props.timesheetNonChargableList || []);
        setOriginalNonChargable(props.timesheetNonChargableList || []);
        setExpenses(props.tsExpenses || []);
        setOriginalExpenses(props.tsExpenses || []);


        // Initialize selectedOptions with user options
        setSelectedChargOptions({
            name: (props.usersJobCodeChargOptions || []).map(({ label }) => label),
            jobno: (props.usersJobCodeChargOptions || []).map(({ value }) => value),
        });

        setSelectedNonChargOptions({
            name: (props.usersJobCodeNonChargOptions || []).map(({ label }) => label),
            jobno: (props.usersJobCodeNonChargOptions || []).map(({ value }) => value),
        });
        setSelectedExpOptions({
            jobno: (props.usersExpCodeOptions || []).map(({ value }) => value),
        })

        const fetchPhaseCodeOptions = async (list, isChargable) => {
            if (!list) return;
            const phaseCodeOptionsByIndex = [];

            await Promise.all(
                list.map(async (item, index) => {
                    const val = item.jobno;
                    try {
                        const resp = await loadPhaseCodeForClient(val);
                        // Store the response at the correct index
                        if (isChargable)
                            phaseCodeOptionsByIndex[index] = resp.UsersChargPhaseCode;
                        else phaseCodeOptionsByIndex[index] = resp.UsersNonChargPhaseCode;
                    } catch (error) {
                        console.error(`Failed to load phase code for jobno ${val}`, error);
                        phaseCodeOptionsByIndex[index] = [];
                    }
                })
            );
            return phaseCodeOptionsByIndex;
        }

        async function loadChargOptions() {
            if (props.isMonthlyTimesheet) {
                // Combine Period A and B into a single array
                const combinedChargableList = [
                    ...(props.timesheetChargableList.periodA || []),
                    ...(props.timesheetChargableList.periodB || [])
                ];

                const charg = await fetchPhaseCodeOptions(combinedChargableList, true);
                setPhaseCodeChargOptionsByIndex(charg);
            } else {
                const charg = await fetchPhaseCodeOptions(props.timesheetChargableList, true);
                setPhaseCodeChargOptionsByIndex(charg);
            }
        }
        loadChargOptions();
        async function loadNonChargOptions() {
            if (props.isMonthlyTimesheet) {
                // Combine Period A and B into a single array
                const combinedNonChargableList = [
                    ...(props.timesheetNonChargableList.periodA || []),
                    ...(props.timesheetNonChargableList.periodB || [])
                ];

                const charg = await fetchPhaseCodeOptions(combinedNonChargableList, false);
                setPhaseCodeNonChargOptionsByIndex(charg);
            } else {
                const charg = await fetchPhaseCodeOptions(props.timesheetNonChargableList, false);
                setPhaseCodeNonChargOptionsByIndex(charg);
            }
        }
        loadNonChargOptions();
        setIsLoading(false);
    }, [props.timesheetChargableList, props.timesheetNonChargableList, props.tsExpenses]);

    useEffect(() => {
        setIsLoading(true);
        props.loadTimesheetDetails(props.tsUI);
        setSelectedWeekIndexChargeable(0);
        setSelectedWeekIndexNonChargeable(0);
        setIsLoading(false);
    }, [props.tsUI])

    useEffect(() => {
        setIsLoading(true);
        setToView(false);
        props.loadTimesheetInfo(props.tsUI)
        setIsLoading(false);
    }, [props.tsUI])

    useEffect(() => {
        if (props.tsInfo && props.tsInfo.length > 0) {
            if (props.isMonthlyTimesheet) {
                if ((props.tsInfo[0].periodA[0].isSubmitted || props.tsInfo[0].periodA[0].isApproved) || props.isApprover) {
                    setToView(true)
                } else { setToView(false) }
            } else {
                if ((props.tsInfo[0].isSubmitted || props.tsInfo[0].isApproved) || props.isApprover) {
                    setToView(true)
                } else { setToView(false) }
            }
        }

        if (props.isMonthlyTimesheet && props.tsUI.tsnoUIA && props.tsUI.tsnoUIB) {
            // Load expenses for both Period A and B
            Promise.all([
                loadExpenseAttachments(props.tsUI.tsnoUIA),
                loadExpenseAttachments(props.tsUI.tsnoUIB)
            ])
                .then(([attachmentsA, attachmentsB]) => {
                    const combinedAttachments = {
                        periodA: attachmentsA,
                        periodB: attachmentsB
                    };
                    // Combined Attachments:  { periodA: [], periodB: [] }
                    setAttachments(combinedAttachments);
                    setOriginalAttachments(combinedAttachments);
                    setChangesAttachments([]);
                    setDeletedAttachments([]);
                })
                .catch((error) => {
                    console.error("Load attachments error", error);
                });
        } else {
            // Calendar month or single timesheet
            loadExpenseAttachments(props.tsUI)
                .then((resp) => {
                    setAttachments(resp);
                    setOriginalAttachments(resp);
                    setChangesAttachments([]);
                    setDeletedAttachments([]);
                })
                .catch((error) => {
                    console.error("Load attachments error", error);
                });
        }
    }, [props.tsInfo[0]])

    useEffect(() => {
        navigation.setOptions({
            title: t('navigate:MT')
        });
    }, []);
    //#endregion

    //#region Edit Handlers
    const handleEditPressChargable = useCallback((idx, item, key, value) => {
        rowEdit(idx, item, key, value, changesChargable, setChangesChargable, chargable, setChargable);
    }, [changesChargable, chargable]);

    const handleEditPressNonChargable = useCallback((idx, item, key, value) => {
        rowEdit(idx, item, key, value, changesNonChargable, setChangesNonChargable, nonChargable, setNonChargable);
    }, [changesNonChargable, nonChargable]);

    const handleEditPressExpense = useCallback((idx, item, key, value) => {
        rowEdit(idx, item, key, value, changesExpenses, setChangesExpenses, expenses, setExpenses);
    }, [changesExpenses, expenses]);

    const handleEditPressChargableMonthly = useCallback((idx, item, key, value, period) => {
        const periodKey = `period${period}`;
        const currentPeriodData = chargable[periodKey] || [];

        // Then manually update the state based on what rowEdit does
        setChangesChargable(prev => {
            const periodChanges = prev[periodKey] || {};
            const c = { ...periodChanges };

            if (idx in c) {
                c[idx] = {
                    ...c[idx],
                    [key]: value,
                };
            } else {
                c[idx] = {
                    ...item,
                    [key]: value,
                };
            }

            return {
                ...prev,
                [periodKey]: c
            };
        });

        setChargable(prev => ({
            ...prev,
            [periodKey]: currentPeriodData.map((row, index) =>
                index === idx ? { ...row, [key]: value } : row
            )
        }));
    }, [changesChargable, chargable]);

    const handleEditPressNonChargableMonthly = useCallback((idx, item, key, value, period) => {
        const periodKey = `period${period}`;
        const currentPeriodData = nonChargable[periodKey] || [];

        // Then manually update the state based on what rowEdit does
        setChangesNonChargable(prev => {
            const periodChanges = prev[periodKey] || {};
            const c = { ...periodChanges };

            if (idx in c) {
                c[idx] = {
                    ...c[idx],
                    [key]: value,
                };
            } else {
                c[idx] = {
                    ...item,
                    [key]: value,
                };
            }

            return {
                ...prev,
                [periodKey]: c
            };
        });

        setNonChargable(prev => ({
            ...prev,
            [periodKey]: currentPeriodData.map((row, index) =>
                index === idx ? { ...row, [key]: value } : row
            )
        }));
    }, [changesNonChargable, nonChargable]);

    const handleOvertimePaymentChange = (value) => {
        props.setTSInfo(prev => {
            if (!prev || prev.length === 0) return prev;
            const updated = {
                ...prev[0],
                inCash: value === 'cash',
                inTimeOff: value === 'time_off',
            };
            return [updated];
        });
    };

    const handleOvertimePaymentChangeMonthly = (value) => {
        props.setTSInfo(prev => {
            if (!prev || prev.length === 0) return prev;

            const updated = {
                ...prev[0],
                periodA: [{
                    ...prev[0].periodA[0],
                    inCash: value === 'cash',
                    inTimeOff: value === 'time_off',
                }],
                periodB: [{
                    ...prev[0].periodB[0],
                    inCash: value === 'cash',
                    inTimeOff: value === 'time_off',
                }]
            };

            return [updated];
        });
    };
    //#endregion

    //#region Delete Handlers
    const handleDeleteChargable = (item, index, attribute) => {
        if (props.isMonthlyTimesheet) {
            // monthly timesheet: determine which period the item belongs to
            const period = getPeriodFromWeekIndex(selectedWeekIndexChargeable);
            const periodKey = `period${period}`;

            // Remove from chargable
            setChargable(prev => ({
                ...prev,
                [periodKey]: (prev[periodKey] || []).filter((_, idx) => idx !== index)
            }));

            // Add rowguid to deletedChargable if it exists
            if (item.rowguid) {
                setDeletedChargable(prev => [...prev, item.rowguid]);
            }
        } else {
            rowDelete(item, index, attribute, changesChargable, setChangesChargable, chargable, setChargable, setDeletedChargable, refChargable);
        }
    };

    const handleDeleteNonChargable = (item, index, attribute) => {
        if (props.isMonthlyTimesheet) {
            // monthly timesheet: determine which period the item belongs to
            const period = getPeriodFromWeekIndex(selectedWeekIndexNonChargeable);
            const periodKey = `period${period}`;

            // Remove from nonChargable
            setNonChargable(prev => ({
                ...prev,
                [periodKey]: (prev[periodKey] || []).filter((_, idx) => idx !== index)
            }));

            // Add rowguid to deletedNonChargable if it exists
            if (item.rowguid) {
                setDeletedNonChargable(prev => [...prev, item.rowguid]);
            }
        } else {
            // period timesheet: use original logic
            rowDelete(item, index, attribute, changesNonChargable, setChangesNonChargable, nonChargable, setNonChargable, setDeletedNonChargable, refNonChargable);
        }
    };

    const handleDeleteExpense = (item, index, attribute) => {
        rowDelete(item, index, attribute, changesExpenses, setChangesExpenses, expenses, setExpenses, setDeletedExpenses, refExpenses);
    };
    //#endregion

    //#region Add New Entry
    const createEmptyEntry = () => {
        const emptyDays = {};
        for (let i = 1; i <= 16; i++) {
            emptyDays[`d${i}`] = 0;
        }
        return {
            rowguid: generateUniqueID(),
            tsnoui: props.tsUI || '',
            description: '',
            name: '',
            jobno: '',
            phasecode: '',
            ...emptyDays,
        };
    };

    const createEmptyEntryMonthly = (period) => {
        const emptyDays = {};
        for (let i = 1; i <= 16; i++) {
            emptyDays[`d${i}`] = 0;
        }
        return {
            rowguid: generateUniqueID(),
            tsnoui: period === 'A' ? props.tsUI.tsnoUIA : props.tsUI.tsnoUIB,
            description: '',
            name: '',
            jobno: '',
            phasecode: '',
            ...emptyDays,
        };
    };

    const createEmptyEntryExp = () => {
        return {
            rowguid: generateUniqueID(),
            tsnoui: props.tsUI || '',
            company: '',
            jobno: '',
            date: new Date(),
            expcode: '',
            expdescr: '',
            rateofunit: 0,
            unitofmeasure: '',
            units: 0,
        };
    };

    const handleAddNewChargable = () => {
        setChargable(prev => [...prev, createEmptyEntry()]);
    };

    const handleAddNewNonChargable = () => {
        setNonChargable(prev => [...prev, createEmptyEntry()]);
    };

    const handleAddNewExpenses = () => {
        setExpenses(prev => [...prev, createEmptyEntryExp()]);
    };

    const handleAddNewChargableMonthly = () => {
        const period = getPeriodFromWeekIndex(selectedWeekIndexChargeable);
        const newEntry = createEmptyEntryMonthly(period);

        setChargable(prev => {
            const updated = { ...prev };
            if (period === 'A') {
                updated.periodA = [...(prev.periodA || []), newEntry];
            } else {
                updated.periodB = [...(prev.periodB || []), newEntry];
            }
            return updated;
        });
    };

    const handleAddNewNonChargableMonthly = () => {
        const period = getPeriodFromWeekIndex(selectedWeekIndexNonChargeable);
        const newEntry = createEmptyEntryMonthly(period);

        setNonChargable(prev => {
            const updated = { ...prev };
            if (period === 'A') {
                updated.periodA = [...(prev.periodA || []), newEntry];
            } else {
                updated.periodB = [...(prev.periodB || []), newEntry];
            }
            return updated;
        });
    };
    //#endregion

    //#region Cancel Changes
    const handleCancelChargable = () => {
        const rolledBackChargable = originalChargable.map(obj => ({ ...obj }));
        setChargable(rolledBackChargable);
        setDeletedChargable([]);
        setChangesChargable({});
        showMessage({
            message: t("common:changesCancelled"),
            type: "info",
            duration: 3000,
        });
    };

    const handleCancelNonChargable = () => {
        const rolledBackNonChargable = originalNonChargable.map(obj => ({ ...obj }));
        setNonChargable(rolledBackNonChargable);
        setDeletedNonChargable([]);
        setChangesNonChargable({});
        showMessage({
            message: t("common:changesCancelled"),
            type: "info",
            duration: 3000,
        });
    };

    const handleCancelExpenses = () => {
        const rolledBackExpenses = originalExpenses.map(obj => ({ ...obj }));
        setExpenses(rolledBackExpenses);
        setDeletedExpenses([]);
        setChangesExpenses({});
        setAttachments(originalAttachments);
        setChangesAttachments([]);
        setDeletedAttachments([]);
        showMessage({
            message: t("common:changesCancelled"),
            type: "info",
            duration: 3000,
        });
    };

    const handleCancelChargableMonthly = () => {
        setChargable({
            periodA: (originalChargable.periodA || []).map(obj => ({ ...obj })),
            periodB: (originalChargable.periodB || []).map(obj => ({ ...obj }))
        });
        setDeletedChargable([]);
        setChangesChargable({ periodA: {}, periodB: {} });
        showMessage({
            message: t("common:changesCancelled"),
            type: "info",
            duration: 3000,
        });
    };

    const handleCancelNonChargableMonthly = () => {
        setNonChargable({
            periodA: (originalNonChargable.periodA || []).map(obj => ({ ...obj })),
            periodB: (originalNonChargable.periodB || []).map(obj => ({ ...obj }))
        });
        setDeletedNonChargable([]);
        setChangesNonChargable({ periodA: {}, periodB: {} });
        showMessage({
            message: t("common:changesCancelled"),
            type: "info",
            duration: 3000,
        });
    };
    //#endregion

    //#region Save Handlers
    //#region Save/Delete Function
    const saveAndDeleteTimesheetLines = async (dataToSave, deletedItems, isSaveAll) => {
        try {
            let savePromises = [];
            let updateSucc = true;
            let deleteSucc = true;
            // Save updated/added lines
            savePromises.push(
                saveTimesheetLines(dataToSave)
                    .then((resp) => {
                        updateSucc = resp;
                    })
                    .catch((error) => {
                        updateSucc = false;
                    })
            );

            // Delete removed lines
            if (deletedItems.length > 0) {
                savePromises.push(
                    deleteTimesheetLines(deletedItems)
                        .then((res) => {
                            deleteSucc = res;
                        })
                        .catch((error) => {
                            deleteSucc = false;
                        })
                );
            }

            await Promise.all(savePromises);

            if (!updateSucc || !deleteSucc) {
                if (!isSaveAll) {
                    showMessage({
                        message: t("common:tsErrorSaving"),
                        type: "danger",
                        duration: 3000,
                    });
                }
                return false;
            }

            return true;
        } catch (error) {
            showMessage({
                message: t("common:errorSave"),
                type: "danger",
                duration: 3000,
            });
            return false;
        }
    };
    //#endregion

    //#region SaveChargable
    const validateTSLines = (data) => {
        // Validation: check required fields for timsheet lines
        // Handle both array and object (monthly) structures
        const itemsToValidate = Array.isArray(data) ? data : [
            ...(data.periodA || []),
            ...(data.periodB || [])
        ];

        for (let i = 0; i < itemsToValidate.length; i++) {
            const item = itemsToValidate[i];
            if (!item.description || item.description.toString().trim() === '') {
                showMessage({
                    message: t('common:descriptionRequired'),
                    type: "danger",
                    duration: 3000,
                });
                return false;
            }
            if (!item.jobno || item.jobno.toString().trim() === '') {
                showMessage({
                    message: t('common:jobNoRequired'),
                    type: "danger",
                    duration: 3000,
                });
                return false;
            }
            if (!props.isMonthlyTimesheet && (!item.phasecode || item.phasecode.toString().trim() === '')) {
                showMessage({
                    message: t('common:phaseCodeRequired'),
                    type: "danger",
                    duration: 3000,
                });
                return false;
            }
        }
        return true;
    }

    // Validation function to check if all days meet minimum standard units
    // For monthly: days 1-16 from periodA, days 17+ from periodB
    const validateCompleteDays = (data) => {
        let dates = [];
        if(props.isWeekly) {
            let currentDate = new Date(props.tsInfo[0].weekStart);
            const endDate = new Date(props.tsInfo[0].weekEnd);
            while (currentDate <= endDate) {
                dates.push(new Date(currentDate));
                currentDate.setDate(currentDate.getDate() + 1);
            }
        } else if(props.isMonthlyTimesheet) {
            dates = getMonthDates(props.tsInfo[0].periodA[0].year, props.tsInfo[0].periodB[0].month);
        } else {
            dates = getPeriodDates(props.tsInfo[0].year, props.tsInfo[0].month, props.tsInfo[0].period);
        }
        
        const { standardUnits } = props.isWeekly ? getInitialValues(dates) : (props.isMonthlyTimesheet ? getInitialValuesMonthly(dates) : getInitialValues(dates));
        
        const timesheetTotals = [];
        const maxDays = props.isWeekly ? 7 : (props.isMonthlyTimesheet ? dates.length : 16);
        for (let i = 1; i <= maxDays; i++) {
            timesheetTotals.push(totals[`d${i}`] || 0.0);
        }
        
        // For monthly timesheets, check periodA (days 1-16) and periodB (days 17+) separately
        if (props.isMonthlyTimesheet) {
            // Check Period A (days 1-16)
            for (let i = 0; i < 16 && i < timesheetTotals.length && i < standardUnits.length; i++) {
                if (timesheetTotals[i] < standardUnits[i]) {
                    showMessage({
                        message: t('common:incompleteDays'),
                        type: "warning",
                        duration: 4000,
                    });
                    return false;
                }
            }
            
            // Check Period B (days 17+)
            for (let i = 16; i < timesheetTotals.length && i < standardUnits.length; i++) {
                if (timesheetTotals[i] < standardUnits[i]) {
                    showMessage({
                        message: t('common:incompleteDays'),
                        type: "warning",
                        duration: 4000,
                    });
                    return false;
                }
            }
        } else {
            // For non-monthly timesheets (weekly or period)
            for (let i = 0; i < timesheetTotals.length && i < standardUnits.length; i++) {
                if (timesheetTotals[i] < standardUnits[i]) {
                    showMessage({
                        message: t('common:incompleteDays'),
                        type: "warning",
                        duration: 4000,
                    });
                    return false;
                }
            }
        }
        
        return true;
    };

    // Validation function to check if hours exceed allowed limits per date
    // Validates that chargable + non-chargable hours don't exceed standard units for each day
    const validateHoursPerDate = (data, isChargable = true) => {
        // If data is empty, validation passes
        if (!data || (Array.isArray(data) && data.length === 0) ||
            (typeof data === 'object' && !Array.isArray(data) &&
                (!data.periodA || data.periodA.length === 0) &&
                (!data.periodB || data.periodB.length === 0))) {
            return true;
        }

        // Prepare data to check based on timesheet type
        let dataToCheck = [];
        if (props.isMonthlyTimesheet) {
            dataToCheck = data; // Keep as object with periodA and periodB
        } else {
            dataToCheck = Array.isArray(data) ? data : [];
        }

        // Get the standard units (max hours) from timeScheme
        let dates = [];
        if (props.isWeekly) {
            let currentDate = new Date(props.tsInfo[0].weekStart);
            const endDate = new Date(props.tsInfo[0].weekEnd);
            while (currentDate <= endDate) {
                dates.push(new Date(currentDate));
                currentDate.setDate(currentDate.getDate() + 1);
            }
        } else if (props.isMonthlyTimesheet) {
            dates = getMonthDates(props.tsInfo[0].periodA[0].year, props.tsInfo[0].periodB[0].month);
        } else {
            dates = getPeriodDates(props.tsInfo[0].year, props.tsInfo[0].month, props.tsInfo[0].period);
        }

        const { standardUnits } = props.isWeekly
            ? getInitialValues(dates)
            : (props.isMonthlyTimesheet ? getInitialValuesMonthly(dates) : getInitialValues(dates));

        // Get the other data type (if validating chargable, get non-chargable and vice versa)
        const otherData = isChargable ? nonChargable : chargable;
        const maxDays = props.isWeekly ? 7 : (props.isMonthlyTimesheet ? dates.length : 16);

        // For monthly timesheets, check periodA (days 1-16) and periodB (days 17+) separately
        if (props.isMonthlyTimesheet) {
            // Check Period A (days 1-16)
            const periodAItems = dataToCheck.periodA || [];
            const otherPeriodAItems = otherData.periodA || [];

            for (let itemIndex = 0; itemIndex < periodAItems.length; itemIndex++) {
                const item = periodAItems[itemIndex];

                // Skip empty items
                if (!item || (item.description === '' && item.jobno === '')) {
                    continue;
                }

                for (let i = 1; i <= 16; i++) {
                    const dayKey = `d${i}`;
                    const currentHours = parseFloat(item[dayKey], 10) || 0.0;

                    // Calculate total hours from the other data type for this day
                    let otherHours = 0.0;
                    for (let otherItem of otherPeriodAItems) {
                        const otherVal = parseFloat(otherItem[dayKey], 10) || 0.0;
                        otherHours += otherVal;
                    }

                    // Total hours for this day
                    const totalHours = currentHours + otherHours;
                    const maxHoursForDay = standardUnits[i - 1];

                    if (totalHours > maxHoursForDay) {
                        showMessage({
                            message: t('common:exceedsMaxHours'),
                            type: "danger",
                            duration: 4000,
                        });
                        return false;
                    }
                }
            }

            // Check Period B (days 17+)
            const periodBItems = dataToCheck.periodB || [];
            const otherPeriodBItems = otherData.periodB || [];

            for (let itemIndex = 0; itemIndex < periodBItems.length; itemIndex++) {
                const item = periodBItems[itemIndex];

                // Skip empty items
                if (!item || (item.description === '' && item.jobno === '')) {
                    continue;
                }

                for (let i = 1; i <= (dates.length - 16); i++) {
                    const dayKey = `d${i}`;
                    const currentHours = parseFloat(item[dayKey], 10) || 0.0;

                    // Calculate total hours from the other data type for this day
                    let otherHours = 0.0;
                    for (let otherItem of otherPeriodBItems) {
                        const otherVal = parseFloat(otherItem[dayKey], 10) || 0.0;
                        otherHours += otherVal;
                    }

                    // Total hours for this day
                    const totalHours = currentHours + otherHours;
                    const maxHoursForDay = standardUnits[16 + i - 1];
                    
                    if (totalHours > maxHoursForDay) {
                        showMessage({
                            message: t('common:exceedsMaxHours'),
                            type: "danger",
                            duration: 4000,
                        });
                        return false;
                    }
                }
            }
        } else {
            // For non-monthly timesheets (weekly or period)
            const itemsToCheck = Array.isArray(dataToCheck) ? dataToCheck : [];
            const otherItemsToCheck = Array.isArray(otherData) ? otherData : [];

            for (let itemIndex = 0; itemIndex < itemsToCheck.length; itemIndex++) {
                const item = itemsToCheck[itemIndex];

                // Skip empty items
                if (!item || (item.description === '' && item.jobno === '')) {
                    continue;
                }

                for (let i = 1; i <= maxDays; i++) {
                    const dayKey = `d${i}`;
                    const currentHours = parseFloat(item[dayKey], 10) || 0.0;

                    // Calculate total hours from the other data type for this day
                    let otherHours = 0;
                    for (let otherItem of otherItemsToCheck) {
                        const otherVal = parseFloat(otherItem[dayKey], 10) || 0.0;
                        otherHours += otherVal;
                    }

                    // Total hours for this day
                    const totalHours = currentHours + otherHours;
                    const maxHoursForDay = standardUnits[i - 1] ;

                    if (totalHours > maxHoursForDay) {
                        const dataType = isChargable ? 'chargeable' : 'non-chargeable';
                        showMessage({
                            message: t('common:exceedsMaxHours'),
                            type: "danger",
                            duration: 4000,
                        });
                        return false;
                    }
                }
            }
        }

        return true;
    };

    const handleSaveChargable = async (isSaveAll = false) => {
        try {
            const tsInfoToCheck = props.isMonthlyTimesheet ? props.tsInfo[0].periodA[0] : props.tsInfo[0];
            const showOvertime = tsInfoToCheck.inCash || tsInfoToCheck.inTimeOff;

            if (!validateTSLines(chargable)) return;
            if (!showOvertime && !validateHoursPerDate(chargable, true)) return;

            if (props.isMonthlyTimesheet) {
                // Monthly Timesheet: save periodA and periodB separately
                const periodAChangesExist = Object.keys(changesChargable.periodA || {}).length > 0 || deletedChargable.length > 0;
                const periodBChangesExist = Object.keys(changesChargable.periodB || {}).length > 0 || deletedChargable.length > 0;

                if (!periodAChangesExist && !periodBChangesExist) {
                    if (!isSaveAll) {
                        showMessage({
                            message: t('common:noChanges'),
                            type: "warning",
                            duration: 3000,
                        });
                    }
                    return true;
                }

                // Save Period A
                if (periodAChangesExist) {
                    const successA = await saveAndDeleteTimesheetLines(
                        chargable.periodA || [],
                        deletedChargable,
                        isSaveAll
                    );
                    if (!successA) return false;
                }

                // Save Period B
                if (periodBChangesExist) {
                    const successB = await saveAndDeleteTimesheetLines(
                        chargable.periodB || [],
                        deletedChargable,
                        isSaveAll
                    );
                    if (!successB) return false;
                }

                // Update original data and clear changes
                setOriginalChargable({
                    periodA: chargable.periodA || [],
                    periodB: chargable.periodB || []
                });
                setChangesChargable({
                    periodA: {},
                    periodB: {}
                });
                setDeletedChargable([]);
            } else {
                // Period Timesheet: save as array
                const changesExist = Object.keys(changesChargable).length > 0 || deletedChargable.length > 0;

                if (!changesExist) {
                    if (!isSaveAll) {
                        showMessage({
                            message: t('common:noChanges'),
                            type: "danger",
                            duration: 3000,
                        });
                    }
                    return true;
                }

                const success = await saveAndDeleteTimesheetLines(
                    chargable,
                    deletedChargable,
                    isSaveAll
                );
                if (!success) return false;

                // Update original data and clear changes
                setOriginalChargable(chargable);
                setChangesChargable({});
                setDeletedChargable([]);
            }

            if (!isSaveAll) {
                showMessage({
                    message: t("common:changesSavedSuccessfully"),
                    type: "success",
                    duration: 3000,
                });
            }
            return true;
        } catch (error) {
            showMessage({
                message: t("common:errorSave"),
                type: "danger",
                duration: 3000,
            });
        }
    };
    //#endregion

    //#region Save Non-Chargable
    const handleSaveNonChargable = async (isSaveAll = false) => {
        try {
            const tsInfoToCheck = props.isMonthlyTimesheet ? props.tsInfo[0].periodA[0] : props.tsInfo[0];
            const showOvertime = tsInfoToCheck.inCash || tsInfoToCheck.inTimeOff;

            if (!validateTSLines(nonChargable)) return;
            if (!showOvertime && !validateHoursPerDate(nonChargable, false)) return;

            if (props.isMonthlyTimesheet) {
                // monthly: save periodA and periodB separately
                const periodAChangesExist = Object.keys(changesNonChargable.periodA || {}).length > 0 || deletedNonChargable.length > 0;
                const periodBChangesExist = Object.keys(changesNonChargable.periodB || {}).length > 0 || deletedNonChargable.length > 0;

                if (!periodAChangesExist && !periodBChangesExist) {
                    if (!isSaveAll) {
                        showMessage({
                            message: t('common:noChanges'),
                            type: "danger",
                            duration: 3000,
                        });
                    }
                    return true;
                }

                // Save Period A
                if (periodAChangesExist) {
                    const successA = await saveAndDeleteTimesheetLines(
                        nonChargable.periodA || [],
                        deletedNonChargable,
                        isSaveAll
                    );
                    if (!successA) return false;
                }

                // Save Period B
                if (periodBChangesExist) {
                    const successB = await saveAndDeleteTimesheetLines(
                        nonChargable.periodB || [],
                        deletedNonChargable,
                        isSaveAll
                    );
                    if (!successB) return false;
                }

                // Update original data and clear changes
                setOriginalNonChargable({
                    periodA: nonChargable.periodA || [],
                    periodB: nonChargable.periodB || []
                });
                setChangesNonChargable({
                    periodA: {},
                    periodB: {}
                });
                setDeletedNonChargable([]);
            } else {
                // period timesheet
                const changesExist = Object.keys(changesNonChargable).length > 0 || deletedNonChargable.length > 0;

                if (!changesExist) {
                    if (!isSaveAll) {
                        showMessage({
                            message: t('common:noChanges'),
                            type: "danger",
                            duration: 3000,
                        });
                    }
                    return true;
                }

                const success = await saveAndDeleteTimesheetLines(
                    nonChargable,
                    deletedNonChargable,
                    isSaveAll
                );
                if (!success) return false;

                // Update original data and clear changes
                setOriginalNonChargable(nonChargable);
                setChangesNonChargable({});
                setDeletedNonChargable([]);
            }

            if (!isSaveAll) {
                showMessage({
                    message: t("common:changesSavedSuccessfully"),
                    type: "success",
                    duration: 3000,
                });
            }
            return true;
        } catch (error) {
            showMessage({
                message: t("common:errorSave"),
                type: "danger",
                duration: 3000,
            });
        }
    };
    //#endregion

    //#region SaveTS
    const handleSaveTimesheet = async () => {
        try {
            setIsLoading(true);

            // save chargable and non-chargable
            const chargeableSuccess = await handleSaveChargable(true);
            const nonChargeableSuccess = await handleSaveNonChargable(true);

            if (!chargeableSuccess || !nonChargeableSuccess) {
                showMessage({
                    message: t("common:errorSave"),
                    type: "danger",
                    duration: 3000,
                });
                setIsLoading(false);
                return;
            }

            // Save timesheet info
            if (props.isMonthlyTimesheet) {
                // monthly: save periodA and periodB
                const tsInfoPeriodA = {
                    ...props.tsInfo[0].periodA[0],
                    tsnoui: props.tsUI.tsnoUIA
                };

                const tsInfoPeriodB = {
                    ...props.tsInfo[0].periodB[0],
                    tsnoui: props.tsUI.tsnoUIB
                };

                // Save Period A
                await saveTimesheetInfo(tsInfoPeriodA)
                    .then((res) => {
                        if (res.statusCode !== 200) {
                            showMessage({
                                message: t("common:errorSave"),
                                type: "danger",
                                duration: 3000,
                            });
                        }
                    })
                    .catch((error) => {
                        showMessage({
                            message: t("common:errorSave"),
                            type: "danger",
                            duration: 3000,
                        });
                    });

                // Save Period B
                await saveTimesheetInfo(tsInfoPeriodB)
                    .then((res) => {
                        if (res.statusCode === 200) {
                            showMessage({
                                message: t("common:changesSavedSuccessfully"),
                                type: "success",
                                duration: 3000,
                            });
                        } else {
                            showMessage({
                                message: t("common:errorSave"),
                                type: "danger",
                                duration: 3000,
                            });
                        }
                    })
                    .catch((error) => {
                        showMessage({
                            message: t("common:errorSave"),
                            type: "danger",
                            duration: 3000,
                        });
                    });
            } else {
                if (handleSaveExpenses(true)) {
                    await saveTimesheetInfo(props.tsInfo[0])
                        .then((res) => {
                            if (res.statusCode === 200) {
                                showMessage({
                                    message: t("common:changesSavedSuccessfully"),
                                    type: "success",
                                    duration: 3000,
                                });
                            } else {
                                showMessage({
                                    message: t("common:errorSave"),
                                    type: "danger",
                                    duration: 3000,
                                });
                            }
                        })
                        .catch((error) => {
                            showMessage({
                                message: t("common:errorSave"),
                                type: "danger",
                                duration: 3000,
                            });
                        });
                }
            }
        } catch (error) {
            console.log(error)
            showMessage({
                message: t("common:errorSave"),
                type: "danger",
                duration: 3000,
            });
        } finally {
            setIsLoading(false);
        }
    };
    //#endregion

    //#region Save Expenses
    const validateRequired = () => {
        // Validation: check required fields in expenses
        for (let i = 0; i < expenses.length; i++) {
            const expense = expenses[i];
            if (!expense.jobno || expense.jobno.toString().trim() === '') {
                showMessage({
                    message: t('common:jobNoRequired'),
                    type: "danger",
                    duration: 3000,
                });
                return false;
            }
            if (!expense.doe || expense.doe.toString().trim() === '') {
                showMessage({
                    message: t('common:doeRequired'),
                    type: "danger",
                    duration: 3000,
                });
                return false;
            }
            if (!expense.expcode || expense.expcode.toString().trim() === '') {
                showMessage({
                    message: t('common:expCodeRequired'),
                    type: "danger",
                    duration: 3000,
                });
                return false;
            }
        }
        return true;
    }

    const handleSaveExpenses = async (isSaveAll = false) => {
        try {
            if (!validateRequired()) return;
            if (Object.entries(changesExpenses).length === 0 && deletedExpenses.length === 0 && Object.entries(changesAttachments).length === 0 && deletedAttachments.length === 0) {
                if (!isSaveAll) {
                    showMessage({
                        message: t('common:noChanges'),
                        type: "danger",
                        duration: 3000,
                    });
                }
                return true;
            }

            let savePromises = [];
            let updateSucc = true;
            let deleteSucc = true;
            let attachmentsSucc = true;
            let deleteAttachmentsSucc = true;

            // Save updated/added expense lines
            savePromises.push(
                saveExpenseLines(expenses)
                    .then((res) => {
                        if (res.statusCode === 200) {
                            updateSucc = true;
                        } else {
                            updateSucc = false;
                        }
                    })
                    .catch((error) => {
                        updateSucc = false;
                    })
            );

            // Delete removed expense lines
            if (deletedExpenses.length > 0) {
                savePromises.push(
                    deleteExpenseLines(deletedExpenses)
                        .then((res) => {
                            if (res.statusCode === 200) {
                                deleteSucc = true;
                            } else {
                                deleteSucc = false;
                            }
                        })
                        .catch((error) => {
                            deleteSucc = false;
                        })
                );
            }

            // Save changed attachments if any
            if (changesAttachments.length > 0) {
                savePromises.push(
                    saveAttachments(changesAttachments)
                        .then((res) => {
                            if (res.statusCode === 200) {
                                attachmentsSucc = true;
                            } else {
                                attachmentsSucc = false;
                            }
                        })
                        .catch((error) => {
                            attachmentsSucc = false;
                        })
                );
            }

            // Delete removed attachments if any
            if (deletedAttachments.length > 0) {
                savePromises.push(
                    deleteAttachments(deletedAttachments)
                        .then((res) => {
                            if (res.statusCode === 200) {
                                deleteAttachmentsSucc = true;
                            } else {
                                deleteAttachmentsSucc = false;
                            }
                        })
                        .catch((error) => {
                            deleteAttachmentsSucc = false;
                        })
                );
            }

            await Promise.all(savePromises);

            if (!updateSucc || !deleteSucc || !attachmentsSucc) {
                if (!isSaveAll) {
                    showMessage({
                        message: t("common:tsErrorSaving"),
                        type: "danger",
                        duration: 3000,
                    });
                }
                return false;
            }

            // After successful save, update original data and clear changes
            setOriginalExpenses(expenses);
            setChangesExpenses({});
            setDeletedExpenses([]);
            setOriginalAttachments(attachments)
            setChangesAttachments([]);
            setDeletedAttachments([]);

            if (!isSaveAll) {
                showMessage({
                    message: t("common:changesSavedSuccessfully"),
                    type: "success",
                    duration: 3000,
                });
            }

            return true;
        } catch (error) {
            showMessage({
                message: t("common:errorSave"),
                type: "danger",
                duration: 3000,
            });
            return false;
        }
    };
    //#endregion

    //#region DeleteTS
    const handleDeleteTimesheet = async () => {
        if (props.isMonthlyTimesheet) {
            const deleteA = await deleteTimesheet(props.tsUI.tsnoUIA)
            const deleteB = await deleteTimesheet(props.tsUI.tsnoUIB)

            if (!deleteA || !deleteB) {
                showMessage({
                    message: t("common:errorSave"),
                    type: "danger",
                    duration: 3000,
                });
            }
            props.selectMyTimesheetsScreen();
        }
        deleteTimesheet(props.tsUI).then((res) => {
            if (res === 200)
                props.selectMyTimesheetsScreen();
        })
            .catch((error) => {
                showMessage({
                    message: t("common:errorSave"),
                    type: "danger",
                    duration: 3000,
                });
            })
    }

    //#region Submit
    const handleSubmitTS = async () => {
        setIsLoading(true)

        // Validate complete days before submitting
        if (!validateCompleteDays(chargable)) {
            setIsLoading(false);
            return;
        }
        
        if (props.isMonthlyTimesheet) {
            const subA = await submitTimesheet(props.tsUI.tsnoUIA)
            const subB = await submitTimesheet(props.tsUI.tsnoUIB)

            if (subA && subB) {
                showMessage({
                    message: t("common:submittedSuccess"),
                    type: "success",
                    duration: 3000,
                });
                setToView(true)
                props.loadTimesheetDetails(props.tsUI);
                props.loadTimesheetInfo(props.tsUI);
            } else {
                showMessage({
                    message: t("common:errorSubmit"),
                    type: "danger",
                    duration: 3000,
                });
            }
        } else {
            const sub = await submitTimesheet(props.tsUI)
            if (sub) {
                showMessage({
                    message: t("common:submittedSuccess"),
                    type: "success",
                    duration: 3000,
                });
                setToView(true)
                props.loadTimesheetDetails(props.tsUI);
                props.loadTimesheetInfo(props.tsUI);
            } else {
                showMessage({
                    message: t("common:errorSubmit"),
                    type: "danger",
                    duration: 3000,
                });
            }
        }
        setIsLoading(false)
    }
    //#endregion

    //#endregion

    //#region Job name&code Helper
    useEffect(() => {
        const syncJobFields = async (list, setList, jobCodeOptions, selectedOptions, setSelectedOptions) => {

            const isMonthlyList = list && typeof list === 'object' && !Array.isArray(list) && ('periodA' in list || 'periodB' in list);

            if (isMonthlyList) {
                // Handle monthly timesheet (object with periodA/periodB)
                let updatedA = false;
                let updatedB = false;

                const processListItems = (items) => {
                    let hasUpdates = false;
                    const processed = items.map(item => {
                        let newItem = { ...item };
                        const matchByName = jobCodeOptions.find(opt => opt.label === item.name);
                        const matchByCode = jobCodeOptions.find(opt => opt.value === item.jobno);

                        if (item.name && isName) {
                            if (matchByName) {
                                newItem.jobno = matchByName.value;
                                hasUpdates = true;
                                if (!selectedOptions.jobno.includes(matchByName.value)) {
                                    setSelectedOptions(prev => ({
                                        ...prev,
                                        jobno: [...prev.jobno, matchByName.value]
                                    }));
                                }
                            }
                        }
                        if (item.jobno && !isName) {
                            if (matchByCode) {
                                newItem.name = matchByCode.label || matchByCode.value;
                                hasUpdates = true;
                                if (!selectedOptions.name.includes(newItem.name)) {
                                    setSelectedOptions(prev => ({
                                        ...prev,
                                        name: [...prev.name, newItem.name]
                                    }));
                                }
                            }
                        }
                        return newItem;
                    });
                    return { processed, hasUpdates };
                };

                const { processed: processedA, hasUpdates: updatedA_flag } = processListItems(list.periodA || []);
                const { processed: processedB, hasUpdates: updatedB_flag } = processListItems(list.periodB || []);

                if (updatedA_flag || updatedB_flag) {
                    setList({
                        periodA: processedA,
                        periodB: processedB
                    });
                }
            } else {
                let updated = false;
                const updatedList = (list || []).map(item => {
                    let newItem = { ...item };
                    // Find matching jobCodeOption by jobname or jobcode
                    const matchByName = jobCodeOptions.find(opt => opt.label === item.name);
                    const matchByCode = jobCodeOptions.find(opt => opt.value === item.jobno);

                    // If jobname exists but jobcode missing update jobcode
                    if (item.name && isName) {
                        if (matchByName) {
                            newItem.jobno = matchByName.value;
                            updated = true;
                            // Add to selected jobno options if not present
                            if (!selectedOptions.jobno.includes(matchByName.value)) {
                                setSelectedOptions(prev => ({
                                    ...prev,
                                    jobno: [...prev.jobno, matchByName.value]
                                }));
                            }
                        }
                    }
                    if (item.jobno && !isName) {
                        // If jobcode exists but jobname missing update jobname
                        if (matchByCode) {
                            newItem.name = matchByCode.label || matchByCode.value;
                            updated = true;
                            // Add to selected name options if not present
                            if (!selectedOptions.name.includes(newItem.name)) {
                                setSelectedOptions(prev => ({
                                    ...prev,
                                    name: [...prev.name, newItem.name]
                                }));
                            }
                        }
                    }
                    return newItem;
                });
                if (updated) {
                    setList(updatedList);
                }
            }
        };

        // Sync chargable list and update selectedChargOptions
        syncJobFields(chargable, setChargable, props.jobCodeChargOptions, selectedChargOptions, setSelectedChargOptions);

        // Sync nonChargable list and update selectedNonChargOptions
        syncJobFields(nonChargable, setNonChargable, props.jobCodeNonChargOptions, selectedNonChargOptions, setSelectedNonChargOptions);
    }, [isName, chargable, nonChargable, props.jobCodeChargOptions, props.jobCodeNonChargOptions, selectedChargOptions, selectedNonChargOptions]);
    //#endregion


    //#region LoadReport
    const openLink = async (url) => {
        try {
            const supported = await Linking.canOpenURL(url);
            if (supported) {
                await Linking.openURL(url);
            } else {
                console.log("Don't know how to open UR");
            }
        } catch (err) {
            console.error("An error occurred", err);
        }
    };
    //#endregion

    //#region PrintTS

    const printTS = (tsnoUI, format = "PDF") => {
        setDisplayLoading(true)
        printTimesheet(tsnoUI)
            .then((res) => {
                setSsrsUrls(prevSsrsUrl => [...prevSsrsUrl, res])
                setDisplayLoading(false);
                //* Display The SSRS Link
                getSSRSEmbeded(res, format).then((embRes) => {
                    setSSRSData(embRes);
                }).catch((error) => console.log(error))
                // openLink(res);
            })
            .catch((error) => {
                setDisplayLoading(false);
                showMessage({
                    message: t("common:errorSave"),
                    type: "danger",
                    duration: 3000,
                });
            })
    }

    //#endregion

    //#region Loading
    if (isLoading)
        return (
            <View style={styles.loader}>
                <ActivityIndicator animating={true} color={colors.blue} />
            </View>
        )
    //#endregion

    return (
        <SafeAreaView style={[styles.submain]}>
            <CustomLabel
                value={
                    !props.isMonthlyTimesheet && !props.isWeekly ? (props.tsInfo[0]
                        ? `${t("common:timesheetDetails")} - ${MONTHS.find(m => m.value === props.tsInfo[0].month)?.description || ''
                        } ${props.tsInfo[0].year} Period ${props.tsInfo[0].period}`
                        : t("common:timesheetDetails")
                    ) : !props.isWeekly ? (
                        props.tsInfo[0]
                            ? `${t("common:timesheetDetails")} - ${MONTHS.find(m => m.value === props.tsInfo[0].periodA[0].month)?.description || ''
                            } ${props.tsInfo[0].periodA[0].year}`
                            : t("common:timesheetDetails")
                    ) : (
                        props.tsInfo[0]
                            ? `${t("common:timesheetDetails")} - ${formatDateForUI(props.tsInfo[0].weekStart)}-${formatDateForUI(props.tsInfo[0].weekEnd)}`
                            : t("common:timesheetDetails")
                    )
                }
                type="MINORTITLE"
            />

            <SafeAreaView style={styles.rowView}>
                {/* Side Menu */}
                <View style={styles.sideMenu}>
                    {SIDE_MENU_OPTIONS.map((option, index) => (
                        props.isEmbedded && (index === 0 || index === 3) ? <></> :
                            (option.key === 'outOfPocket') ?
                                (hasAccess(TASKS.DELIGATE, TASK_OPTIONS.MYOUTOFPOCKETEXP) || isAdmin) &&
                                <TouchableOpacity
                                    key={option.key}
                                    onPress={() => handleSideMenuPress(index)}
                                >
                                    <Card style={[styles.cardStyleServiceLine, buttonStates.pressed[index] === true ? styles.selectedButton : null]} >
                                        <CustomLabel
                                            value={t(option.label)}
                                            type="SIDE_MENU"
                                            style={{ color: buttonStates.pressed[index] ? 'white' : colors.text }}
                                        />
                                    </Card>
                                </TouchableOpacity>
                                :
                                <TouchableOpacity
                                    key={option.key}
                                    onPress={() => handleSideMenuPress(index)}
                                >
                                    <Card style={[styles.cardStyleServiceLine, buttonStates.pressed[index] === true ? styles.selectedButton : null]} >
                                        <CustomLabel
                                            value={t(option.label)}
                                            type="SIDE_MENU"
                                            style={{ color: buttonStates.pressed[index] ? 'white' : colors.text }}
                                        />
                                    </Card>
                                </TouchableOpacity>
                    ))}
                    {/* Total Button at the bottom */}
                    {!props.isEmbedded && <TouchableOpacity
                        key="total"
                        onPress={handleTotalPress}
                        style={{ marginTop: 'auto' }}
                    >
                        <Card style={[styles.cardStyleServiceLine, totalPressed ? styles.selectedButton : null]} >
                            <CustomLabel
                                value={t("common:Total")}
                                type="SIDE_MENU"
                                style={{ color: totalPressed ? 'white' : colors.text }}
                            />
                        </Card>
                    </TouchableOpacity>}
                </View>

                {/* Main Content */}
                <View style={styles.mainContent}>
                    {/* TS info */}
                    {buttonStates.pressed[0] && !props.isEmbedded && (
                        <>
                            <SafeAreaView style={{ padding: 10 }}>
                                <SafeAreaView style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                                    {/* Left Card */}
                                    <Card style={[styles.cardStyleServiceLine, { flex: 1, marginRight: 10 }]}>
                                        <Card.Content>
                                            <SafeAreaView style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                                                {/* Left Column: Year, Month, Period */}
                                                <SafeAreaView style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
                                                    <CustomLabel
                                                        value={t('common:year') + ': ' + (props.tsInfo[0] && props.tsInfo.length > 0 ? (props.isMonthlyTimesheet ? props.tsInfo[0].periodA[0].year : props.tsInfo[0].year) : '')}
                                                        type="SUBTITLE"
                                                        style={{ marginBottom: 10 }} />
                                                    <CustomLabel
                                                        value={t('common:month') + ': ' + (props.tsInfo[0] && props.tsInfo.length > 0
                                                            ? MONTHS.find(m => m.value === (props.isMonthlyTimesheet ? props.tsInfo[0].periodA[0].month : props.tsInfo[0].month))?.description || ''
                                                            : ''
                                                        )}
                                                        type="SUBTITLE" style={{ marginBottom: 10 }}
                                                    />
                                                    {!props.isMonthlyTimesheet && !props.isWeekly && <CustomLabel value={t('common:period') + ': ' + (props.tsInfo[0] && props.tsInfo.length > 0 ? props.tsInfo[0].period : '')} type="SUBTITLE" />}
                                                    {props.isWeekly && <CustomLabel
                                                        value={t('common:week') + ': ' + (props.tsInfo[0] && props.tsInfo.length > 0
                                                            ? `${formatDateForUI(props.tsInfo[0].weekStart)} - ${formatDateForUI(props.tsInfo[0].weekEnd)}`
                                                            : ''
                                                        )}
                                                        type="SUBTITLE" style={{ marginBottom: 10 }}
                                                    />}
                                                </SafeAreaView>

                                                {/* Right Column: Submitted and Approved */}
                                                <SafeAreaView style={{ flexDirection: 'column', justifyContent: 'center' }}>
                                                    <SafeAreaView style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 10 }}>
                                                        <CustomLabel value={t('common:submitted')} type="SUBTITLE" style={{ marginRight: 8 }} />
                                                        <Checkbox
                                                            status={props.tsInfo[0] && props.tsInfo.length > 0 ? (props.isMonthlyTimesheet ? props.tsInfo[0].periodA[0].isSubmitted : props.tsInfo[0].isSubmitted) ? 'checked' : 'unchecked' : 'uncheked'}
                                                            onPress={() => { }}
                                                        />
                                                    </SafeAreaView>
                                                    <SafeAreaView style={{ flexDirection: 'row', alignItems: 'center' }}>
                                                        <CustomLabel value={t('common:approved')} type="SUBTITLE" style={{ marginRight: 8 }} />
                                                        <Checkbox
                                                            status={props.tsInfo[0] && props.tsInfo.length > 0 ? (props.isMonthlyTimesheet ? props.tsInfo[0].periodA[0].isApproved : props.tsInfo[0].isApproved) ? 'checked' : 'unchecked' : 'unchecked'}
                                                            onPress={() => { }}
                                                        />
                                                    </SafeAreaView>
                                                </SafeAreaView>
                                            </SafeAreaView>
                                            {/* Copy functionalities */}
                                            <SafeAreaView style={{ flex: 1, flexFlow: 'wrap', marginTop: '5%', gap: '1%' }}>
                                                {!toView && !props.isMonthlyTimesheet && !props.isWeekly && <>
                                                    {/* Copy Timesheet Button */}
                                                    <TouchableOpacity
                                                        onPress={() => {
                                                            const hasChargeableLines = chargable.length > 0;
                                                            const hasNonChargeableLines = nonChargable.length > 0;
                                                            if (hasChargeableLines || hasNonChargeableLines) {
                                                                showMessage({
                                                                    message: t('common:deleteAllLinesBeforeCopy'),
                                                                    type: 'danger',
                                                                    duration: 4000,
                                                                });
                                                                return false;
                                                            }
                                                            setModalCopyTSVisible(true);
                                                        }}
                                                    >
                                                        <Card style={[styles.cardStyleServiceLine, { flex: 1 }]}>
                                                            <View style={{ flexDirection: 'row', alignItems: 'center', paddingHorizontal: 10 }}>
                                                                <Ionicons name="copy-outline" size={20} />
                                                                <CustomLabel
                                                                    value={t('common:copyTimesheet')}
                                                                    type="SIDE_MENU"
                                                                    style={{ color: colors.text }}
                                                                />
                                                            </View>
                                                        </Card>
                                                    </TouchableOpacity>
                                                    {/* Copy Lines Button */}
                                                    <TouchableOpacity
                                                        onPress={() => {
                                                            const hasChargeableLines = chargable.length > 0;
                                                            const hasNonChargeableLines = nonChargable.length > 0;
                                                            if (hasChargeableLines || hasNonChargeableLines) {
                                                                showMessage({
                                                                    message: t('common:deleteAllLinesBeforeCopy'),
                                                                    type: 'danger',
                                                                    duration: 4000,
                                                                });
                                                                return false;
                                                            }
                                                            setModalCopyTSLinesVisible(true);
                                                        }}
                                                    >
                                                        <Card style={[styles.cardStyleServiceLine, { flex: 1 }]}>
                                                            <View style={{ flexDirection: 'row', alignItems: 'center', paddingHorizontal: 10 }}>
                                                                <Ionicons name="copy-outline" size={20} />
                                                                <CustomLabel
                                                                    value={t('common:copyLines')}
                                                                    type="SIDE_MENU"
                                                                    style={{ color: colors.text }}
                                                                />
                                                            </View>
                                                        </Card>
                                                    </TouchableOpacity>
                                                </>
                                                }
                                                {/* Print Timesheet Button */}
                                                <TouchableOpacity
                                                    onPress={() => {
                                                        if (props.isMonthlyTimesheet) {
                                                            printTS(props.tsUI.tsnoUIA).then(() => {
                                                                printTS(props.tsUI.tsnoUIB)
                                                            })
                                                        } else {
                                                            printTS(props.tsUI)
                                                        }
                                                    }}
                                                >
                                                    <Card style={[styles.cardStyleServiceLine, { flex: 1 }]}>
                                                        <View style={{ flexDirection: 'row', alignItems: 'center', paddingHorizontal: 10 }}>
                                                            <Ionicons name="print-outline" size={20} />
                                                            <CustomLabel
                                                                value={t('common:printTimesheet')}
                                                                type="SIDE_MENU"
                                                                style={{ color: colors.text }}
                                                            />
                                                        </View>
                                                    </Card>
                                                </TouchableOpacity>
                                            </SafeAreaView>
                                            {/* *TODO* MODALS FOR MONTHLY*/}
                                            <Modal
                                                isVisible={modalCopyTSVisible}
                                                hasBackdrop={true}
                                                backdropColor={colors.background_approved}
                                                backdropOpacity={0.9}
                                                width={width}
                                                height={height}
                                                onBackdropPress={() => setModalCopyTSVisible(false)}
                                                onRequestClose={() => setModalCopyTSVisible(false)}
                                            >
                                                <View style={styles.centeredView}>
                                                    <View style={[styles.modalView, { width: '50%' }]}>
                                                        {renderCopyTimesheetModal()}
                                                    </View>
                                                </View>
                                            </Modal>
                                            <Modal
                                                isVisible={modalCopyTSLinesVisible}
                                                hasBackdrop={true}
                                                backdropColor={colors.background_approved}
                                                backdropOpacity={0.9}
                                                width={width}
                                                height={height}
                                                onBackdropPress={() => setModalCopyTSLinesVisible(false)}
                                                onRequestClose={() => setModalCopyTSLinesVisible(false)}
                                            >
                                                <View style={styles.centeredView}>
                                                    <View style={[styles.modalView, { width: '80%' }]}>
                                                        <CopyTimesheetLines
                                                            usersTsList={props.userTimesheetsList}
                                                            MONTH={MONTHS}
                                                            setModalCopyTSLinesVisible={setModalCopyTSLinesVisible}
                                                            toTS={props.tsUI}
                                                            loadTimesheetDetails={props.loadTimesheetDetails}
                                                        />
                                                    </View>
                                                </View>
                                            </Modal>
                                        </Card.Content>
                                    </Card>

                                    {/* Right Card */}
                                    <Card style={[styles.cardStyleServiceLine, { flex: 1, marginLeft: 10 }]}>
                                        <Card.Content>
                                            {/* Overtime Payment Dropdown */}
                                            <SafeAreaView style={{ marginBottom: 15 }}>
                                                <CustomLabel
                                                    value={t('common:wayOfOvertime')}
                                                    type="SUBTITLE"
                                                    style={{ marginBottom: 5, alignItems: 'flex-start' }}
                                                />
                                                <CustomDropDown
                                                    disabled={toView}
                                                    options={[
                                                        { label: 'Overtime is not payable', value: 'not_payable' },
                                                        { label: 'Pay in time off', value: 'time_off' },
                                                        { label: 'Pay in cash', value: 'cash' },
                                                    ]}
                                                    defValue={props.isMonthlyTimesheet ?
                                                        (props.tsInfo[0]
                                                            ? (props.tsInfo[0].periodA[0].inCash
                                                                ? 'cash'
                                                                : (props.tsInfo[0].periodA[0].inTimeOff
                                                                    ? 'time_off'
                                                                    : 'not_payable'))
                                                            : 'not_payable'
                                                        )
                                                        :
                                                        (props.tsInfo[0]
                                                            ? (props.tsInfo[0].inCash
                                                                ? 'cash'
                                                                : (props.tsInfo[0].inTimeOff
                                                                    ? 'time_off'
                                                                    : 'not_payable'))
                                                            : 'not_payable'
                                                        )}
                                                    value={props.isMonthlyTimesheet ?
                                                        (props.tsInfo[0]
                                                            ? (props.tsInfo[0].periodA[0].inCash
                                                                ? 'cash'
                                                                : (props.tsInfo[0].periodA[0].inTimeOff
                                                                    ? 'time_off'
                                                                    : 'not_payable'))
                                                            : 'not_payable'
                                                        )
                                                        :
                                                        (props.tsInfo[0]
                                                            ? (props.tsInfo[0].inCash
                                                                ? 'cash'
                                                                : (props.tsInfo[0].inTimeOff
                                                                    ? 'time_off'
                                                                    : 'not_payable'))
                                                            : 'not_payable'
                                                        )}
                                                    setValue={props.isMonthlyTimesheet ? handleOvertimePaymentChangeMonthly : handleOvertimePaymentChange}
                                                    type="BRANCHES"
                                                />
                                            </SafeAreaView>
                                        </Card.Content>
                                    </Card>
                                </SafeAreaView>
                                {/* Second row card shown only for not submitted timesheets */}
                                {props.tsInfo[0] && props.tsInfo.length > 0 && (props.isMonthlyTimesheet ? !props.tsInfo[0].periodA[0].isSubmitted : !props.tsInfo[0].isSubmitted) &&
                                    <SafeAreaView>
                                        <Card style={[styles.cardStyleServiceLine]}>
                                            <Card.Content style={{ flexDirection: 'column' }}>
                                                {/* Render the rejection comments if exist */}
                                                {(props.isMonthlyTimesheet ? (props.tsInfo[0].periodA[0].comments && props.tsInfo[0].periodA[0].comments !== '') : (props.tsInfo[0].comments && props.tsInfo[0].comments !== '')) && (
                                                    <SafeAreaView>
                                                        <CustomLabel value={t('common:rejCom') + ':'} type="SUBTITLE" />
                                                        <CustomInput
                                                            type='MYPROFILE'
                                                            value={props.isMonthlyTimesheet ? props.tsInfo[0].periodA[0].comments : props.tsInfo[0].comments}
                                                            editable={false}
                                                        />
                                                    </SafeAreaView>
                                                )}
                                                <SafeAreaView style={{ flexDirection: 'row', justifyContent: 'flex-end' }}>
                                                    <CustomButton
                                                        text={t('common:saveAll')}
                                                        onPress={handleSaveTimesheet}
                                                        type={"BUTTON_SAVE"}
                                                        textTop='0'
                                                        isGradient={true}
                                                        sz={15}
                                                    />
                                                    <CustomButton
                                                        text={t('common:delete')}
                                                        onPress={
                                                            () => {
                                                                Swal.fire({
                                                                    title: t("common:areusure"),
                                                                    text: t("common:deleteTSMsg"),
                                                                    icon: "warning",
                                                                    showCancelButton: true,
                                                                    reverseButtons: true,
                                                                    cancelButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">Cancel</text>`,
                                                                    cancelButtonColor: '#d3d3d3',
                                                                    confirmButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">Okay</text>`,
                                                                    confirmButtonColor: '#A0A2FF',
                                                                }).then((result) => {
                                                                    if (result.isConfirmed) {
                                                                        handleDeleteTimesheet();
                                                                    }
                                                                });
                                                            }
                                                        }
                                                        type={"BUTTON_CANCEL"}
                                                        textTop='0'
                                                        sz={15}
                                                    />
                                                    <CustomButton
                                                        text={t('common:submit')}
                                                        onPress={handleSubmitTS}
                                                        type={"BUTTON_SAVE"}
                                                        isGradient={true}
                                                        textTop='0'
                                                        sz={15}
                                                    />
                                                </SafeAreaView>
                                            </Card.Content>
                                        </Card>
                                    </SafeAreaView>
                                }


                            </SafeAreaView>
                            <SafeAreaView style={styles.mainDetails}>
                                {displayLoading &&
                                    <SafeAreaView style={styles.main}><ActivityIndicator animating={true} size='large' color="#86BC25" />
                                    </SafeAreaView>}
                                {ssrsData &&
                                    <iframe
                                        src={ssrsData}
                                        width="100%"
                                        height="100%"
                                        frameBorder="0"
                                    />}
                            </SafeAreaView>
                        </>
                    )}

                    {/* Chargable Tab Content */}
                    {buttonStates.pressed[1] && props.tsInfo[0] && (
                        <SafeAreaView>
                            <ScrollView horizontal showsHorizontalScrollIndicator={true} contentContainerStyle={{ flexGrow: 1 }}>
                                <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <View style={{ flexDirection: 'row', marginBottom: 10 }}>
                                        {weeks.map((week, idx) => {
                                            const start = week[0];
                                            const end = week[week.length - 1];
                                            const label = `${start.toLocaleDateString(undefined, { weekday: 'long', day: '2-digit' })} - ${end.toLocaleDateString(undefined, { weekday: 'long', day: '2-digit' })}`;
                                            return (
                                                <CustomButton
                                                    key={idx}
                                                    text={label}
                                                    onPress={() => setSelectedWeekIndexChargeable(idx)}
                                                    type={selectedWeekIndexChargeable === idx ? "BUTTON_TABMENUSELECTED" : "BUTTON_TABMENU"}
                                                    sz={15}
                                                    style={{ marginRight: 8, minWidth: 120, justifyContent: 'center' }}
                                                    textTop={0}
                                                />
                                            );
                                        })}
                                    </View>
                                    {/* Show buttons to add save cancel if not to view */}
                                    {!toView &&
                                        <SafeAreaView style={{ flexDirection: 'row', justifyContent: 'flex-end', marginBottom: 10 }}>
                                            <CustomButton
                                                text={t('common:newline')}
                                                onPress={props.isMonthlyTimesheet ? handleAddNewChargableMonthly : handleAddNewChargable}
                                                type='BUTTON_ADD'
                                                textTop='0'
                                                sz={15}
                                            />
                                            {((props.isMonthlyTimesheet
                                                ? (
                                                    ((chargable.periodA?.length || 0) + (chargable.periodB?.length || 0)) - ((originalChargable.periodA?.length || 0) + (originalChargable.periodB?.length || 0)) > 0
                                                    || (Object.keys(changesChargable.periodA).length > 0) || (Object.keys(changesChargable.periodB).length > 0)
                                                )
                                                :
                                                (chargable.length - originalChargable.length) > 0 || (Object.keys(changesChargable).length > 0)
                                            ) || deletedChargable.length > 0) && (
                                                    <CustomButton
                                                        text={t('common:save')}
                                                        onPress={() => handleSaveChargable(false)}
                                                        type="BUTTON_SAVE"
                                                        isGradient={true}
                                                        textTop='0'
                                                        sz={15}
                                                    />
                                                )}
                                            {((props.isMonthlyTimesheet
                                                ? (
                                                    ((chargable.periodA?.length || 0) + (chargable.periodB?.length || 0)) - ((originalChargable.periodA?.length || 0) + (originalChargable.periodB?.length || 0)) > 0
                                                    || (Object.keys(changesChargable.periodA).length > 0) || (Object.keys(changesChargable.periodB).length > 0)
                                                )
                                                :
                                                (chargable.length - originalChargable.length) > 0 || (Object.keys(changesChargable).length > 0)
                                            ) || deletedChargable.length > 0) && (
                                                    <CustomButton
                                                        text={t("common:cancel")}
                                                        onPress={props.isMonthlyTimesheet ? handleCancelChargableMonthly : handleCancelChargable}
                                                        type="BUTTON_CANCEL"
                                                        textTop="0"
                                                        sz={15}
                                                    />
                                                )}
                                        </SafeAreaView>
                                    }
                                </View>
                            </ScrollView>
                            {/* Show tables with timesheet lines for chargable */}
                            <TimesheetTable
                                isMonthlyTimesheet={props.isMonthlyTimesheet}
                                startDate={props.startDate}
                                endDate={props.endDate}
                                tsInfo={props.tsInfo}
                                data={props.isMonthlyTimesheet ? (getPeriodFromWeekIndex(selectedWeekIndexChargeable) === 'A' ? (chargable.periodA || []) : (chargable.periodB || [])) : (chargable || [])}
                                isChargable={true}
                                weekDates={weeks[selectedWeekIndexChargeable]}
                                jobCodeOptions={props.jobCodeChargOptions}
                                phaseCodeOptionsByIndex={phaseCodeChargOptionsByIndex}
                                setPhaseCodeOptionsByIndex={setPhaseCodeChargOptionsByIndex}
                                onEdit={props.isMonthlyTimesheet ? handleEditPressChargableMonthly : handleEditPressChargable}
                                onDelete={handleDeleteChargable}
                                toView={toView}
                                formatDateLabel={formatDateLabel}
                                period={props.isMonthlyTimesheet ? getPeriodFromWeekIndex(selectedWeekIndexChargeable) : props.tsInfo[0].period}
                                selectedOptions={selectedChargOptions}
                                setIsName={setIsName}
                                setSelectedOptions={setSelectedChargOptions}
                                loadPhaseCodeForClient={loadPhaseCodeForClient}
                                isEmbedded={props.isEmbedded}
                                isLeftColumnCollapsed={props.isLeftColumnCollapsed || false}
                            />
                        </SafeAreaView>
                    )}

                    {/* Non-Chargable Tab Content */}
                    {buttonStates.pressed[2] && props.tsInfo[0] && (
                        <SafeAreaView>
                            <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', zIndex: 100000 }}>
                                <View style={{ flexDirection: 'row', marginBottom: 10 }}>
                                    {weeks.map((week, idx) => {
                                        const start = week[0];
                                        const end = week[week.length - 1];
                                        const label = `${start.toLocaleDateString(undefined, { weekday: 'long', day: '2-digit' })} - ${end.toLocaleDateString(undefined, { weekday: 'long', day: '2-digit' })}`;
                                        return (
                                            <CustomButton
                                                key={idx}
                                                text={label}
                                                onPress={() => setSelectedWeekIndexNonChargeable(idx)}
                                                type={selectedWeekIndexNonChargeable === idx ? "BUTTON_TABMENUSELECTED" : "BUTTON_TABMENU"}
                                                sz={15}
                                                style={{ marginRight: 8, minWidth: 120, justifyContent: 'center' }}
                                                textTop={0}
                                            />
                                        );
                                    })}
                                </View>
                                {/* Show buttons to add save cancel if not to view */}
                                {!toView &&
                                    <SafeAreaView style={{ flexDirection: 'row', justifyContent: 'flex-end', marginBottom: 10 }}>
                                        <CustomButton
                                            text={t('common:newline')}
                                            onPress={props.isMonthlyTimesheet ? handleAddNewNonChargableMonthly : handleAddNewNonChargable}
                                            type='BUTTON_ADD'
                                            textTop='0'
                                            sz={15}
                                        />
                                        {((props.isMonthlyTimesheet
                                            ? (
                                                ((nonChargable.periodA?.length || 0) + (nonChargable.periodB?.length || 0)) - ((originalNonChargable.periodA?.length || 0) + (originalNonChargable.periodB?.length || 0)) > 0
                                                || (Object.keys(changesNonChargable.periodA).length > 0) || (Object.keys(changesNonChargable.periodB).length > 0)
                                            )
                                            :
                                            (
                                                nonChargable.length - originalNonChargable.length) > 0 || (Object.keys(changesNonChargable).length > 0)
                                        ) || deletedNonChargable.length > 0) && (
                                                <CustomButton
                                                    text={t('common:save')}
                                                    onPress={() => handleSaveNonChargable(false)}
                                                    type="BUTTON_SAVE"
                                                    isGradient={true}
                                                    textTop='0'
                                                    sz={15}
                                                />
                                            )}
                                        {((props.isMonthlyTimesheet
                                            ? (
                                                ((nonChargable.periodA?.length || 0) + (nonChargable.periodB?.length || 0)) - ((originalNonChargable.periodA?.length || 0) + (originalNonChargable.periodB?.length || 0)) > 0
                                                || (Object.keys(changesNonChargable.periodA).length > 0) || (Object.keys(changesNonChargable.periodB).length > 0)
                                            )
                                            :
                                            (
                                                nonChargable.length - originalNonChargable.length) > 0 || (Object.keys(changesNonChargable).length > 0)
                                        ) || deletedNonChargable.length > 0) && (
                                                <CustomButton
                                                    text={t("common:cancel")}
                                                    onPress={props.isMonthlyTimesheet ? handleCancelNonChargableMonthly : handleCancelNonChargable}
                                                    type="BUTTON_CANCEL"
                                                    textTop="0"
                                                    sz={15}
                                                />
                                            )}
                                    </SafeAreaView>
                                }
                            </View>
                            {/* Show tables with timesheet lines for chargable */}
                            <TimesheetTable
                                isMonthlyTimesheet={props.isMonthlyTimesheet}
                                startDate={props.startDate}
                                endDate={props.endDate}
                                tsInfo={props.tsInfo}
                                data={props.isMonthlyTimesheet ? (getPeriodFromWeekIndex(selectedWeekIndexNonChargeable) === 'A' ? (nonChargable.periodA || []) : (nonChargable.periodB || [])) : (nonChargable || [])}
                                isChargable={false}
                                weekDates={weeks[selectedWeekIndexNonChargeable]}
                                jobCodeOptions={props.jobCodeNonChargOptions}
                                phaseCodeOptionsByIndex={phaseCodeNonChargOptionsByIndex}
                                setPhaseCodeOptionsByIndex={setPhaseCodeNonChargOptionsByIndex}
                                onEdit={props.isMonthlyTimesheet ? handleEditPressNonChargableMonthly : handleEditPressNonChargable}
                                onDelete={handleDeleteNonChargable}
                                toView={toView}
                                setIsName={setIsName}
                                formatDateLabel={formatDateLabel}
                                period={props.isMonthlyTimesheet ? getPeriodFromWeekIndex(selectedWeekIndexNonChargeable) : props.tsInfo[0].period}
                                selectedOptions={selectedNonChargOptions}
                                setSelectedOptions={setSelectedNonChargOptions}
                                loadPhaseCodeForClient={loadPhaseCodeForClient}
                                isEmbedded={props.isEmbedded}
                                isLeftColumnCollapsed={props.isLeftColumnCollapsed || false}
                            />
                        </SafeAreaView>
                    )}

                    {/* My Out Of Pocket Expenses Tab Content */}
                    {buttonStates.pressed[3] && !props.isEmbedded && (
                        <SafeAreaView>
                            <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                {/* Upload Documents Button */}
                                {!toView && (
                                    <SafeAreaView style={{ flex: 1, flexDirection: 'row', justifyContent: 'flex-start' }}>
                                        <CustomButton
                                            text={t('common:uploadDocuments')}
                                            onPress={handleUploadDocuments}
                                            iconName="attach-outline"
                                            show='IMPORT'
                                            type='IMPORT'
                                            textTop='0'
                                            sz={25}
                                            isGradient={true}
                                        />
                                    </SafeAreaView>
                                )}
                                {/* Show buttons to add save cancel if not to view */}
                                {!toView &&
                                    <SafeAreaView style={[styles.buttons, styles.functionalityButtons, { flexDirection: 'row', justifyContent: 'flex-end' }]}>
                                        <CustomButton
                                            text={t('common:newline')}
                                            onPress={handleAddNewExpenses}
                                            type='BUTTON_ADD'
                                            textTop='0'
                                            sz={15}
                                        />
                                        {((expenses.length - originalExpenses.length) > 0 || (Object.keys(changesExpenses).length > 0) || deletedExpenses.length > 0 ||
                                            (attachments.length - originalAttachments.length) > 0 || (Object.keys(changesAttachments).length > 0) || deletedAttachments.length > 0
                                        ) && (
                                                <CustomButton
                                                    text={t('common:save')}
                                                    onPress={handleSaveExpenses}
                                                    type="BUTTON_SAVE"
                                                    textTop='0'
                                                    isGradient={true}
                                                    sz={15}
                                                />
                                            )}
                                        {((expenses.length - originalExpenses.length) > 0 || (Object.keys(changesExpenses).length > 0) || deletedExpenses.length > 0 ||
                                            (attachments.length - originalAttachments.length) > 0 || (Object.keys(changesAttachments).length > 0) || deletedAttachments.length > 0
                                        ) && (
                                                <CustomButton
                                                    text={t("common:cancel")}
                                                    onPress={handleCancelExpenses}
                                                    type="BUTTON_CANCEL"
                                                    textTop="0"
                                                    sz={15}
                                                />
                                            )}
                                    </SafeAreaView>
                                }
                            </View>
                            {/* Attachments List Toggle */}
                            <View style={{ marginTop: 'auto' }}>
                                <TouchableOpacity
                                    style={[styles.attachmentList, { flexDirection: 'row', alignSelf: 'flex-start', width: '-webkit-fill-available' }]}
                                    onPress={() => setAttachmentsVisible(!attachmentsVisible)}
                                >
                                    <CustomLabel value={t('common:attachmentsList') + ' (' + attachments.length + ')'} type='SUBTITLE' style={{ fontWeight: 'bold' }} />
                                    <Ionicons
                                        name={attachmentsVisible ? 'chevron-down' : 'chevron-forward'}
                                        size={25}
                                        style={{ marginLeft: 5 }}
                                    />
                                </TouchableOpacity>

                                {/* Attachments List */}
                                {attachmentsVisible && (
                                    <View style={{ marginTop: 5 }}>
                                        {attachments.length === 0 && (
                                            <CustomLabel value={t('common:noAttachments')} type='SUBTITLE' />
                                        )}
                                        {attachments.map((item, index) => (
                                            <View key={index} style={styles.attachmentContainer}>
                                                <View style={styles.attachmentIcons}>
                                                    <Ionicons name="document-outline" style={styles.icons} size={20} />
                                                </View>
                                                <SafeAreaView style={styles.attachmentNameContainer}>
                                                    <CustomLabel value={item.fileName} type='SUBTITLE' style={styles.attachmentNameText} />
                                                </SafeAreaView>
                                                <View style={styles.attachmentIcons}>
                                                    <Menu renderer={renderers.SlideInMenu} style={styles.attachmentMenu}>
                                                        <MenuTrigger>
                                                            <Ionicons name="ellipsis-vertical" style={styles.dotsIcon} />
                                                        </MenuTrigger>
                                                        <MenuOptions customStyles={optionsStyles}>
                                                            <MenuOption onSelect={() => openAttachment(index, item)} customStyles={cancelOptionStyles} text={t('common:open')} />
                                                            {CreateDivider()}
                                                            <MenuOption onSelect={() => downloadAttachment(index, item)} customStyles={cancelOptionStyles} text={t('common:downloadDocument')} />
                                                            {CreateDivider()}
                                                            <MenuOption onSelect={() => removeAttachment(index, item)} customStyles={removeOptionStyles} text={t('common:remove')} />
                                                            {CreateDivider()}
                                                            <MenuOption customStyles={cancelOptionStyles} text={t('common:cancel')} />
                                                        </MenuOptions>
                                                    </Menu>
                                                </View>
                                            </View>
                                        ))}
                                    </View>
                                )}
                            </View>
                            {/* Show tables with expense lines */}
                            <TSExpenseTable
                                data={expenses}
                                entityOptions={props.companiesOptions}
                                jobCodeOptions={props.jobCodeChargOptions}
                                expenseOptions={props.expCode}
                                onEdit={handleEditPressExpense}
                                onDelete={handleDeleteExpense}
                                toView={toView}
                                openCalendar={(index, currentDate) => openCalendarForItem(index, currentDate)}
                                selectedOptions={selectedExpOptions}
                                setSelectedOptions={setSelectedExpOptions}
                            />
                            {calendarVisible && (
                                <>
                                    <View
                                        style={styles.overlay}
                                        onStartShouldSetResponder={() => true}
                                        onResponderRelease={closeCalendar}
                                    />
                                    <SafeAreaView style={styles.calendarOverlay}>
                                        <CustomCalendar
                                            calendarType={"RangePicker"}
                                            setRange={onCalendarDateChange}
                                            range={calendarSelectedData}
                                            allowSingleDate={true}
                                            startingYear={1950}
                                        />
                                    </SafeAreaView>
                                </>
                            )}
                        </SafeAreaView>
                    )}
                    {/* Fixed Total Card at bottom when totalPressed */}
                    {!props.isEmbedded && totalPressed && renderTotalsContainer()}
                </View>
            </SafeAreaView>
        </SafeAreaView>
    );
};

//#region Styles
const makeStyles = (colors, width, height) => StyleSheet.create({
    submain: {
        flex: 1,
        backgroundColor: colors.background_card,
        borderRadius: 35,
        height: "100%",
        elevation: Platform.OS === "web" ? 3 : 0,
        shadowColor: colors.card_line,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.1,
        shadowRadius: Platform.OS === "web" ? 5 : 0,
    },
    rowView: {
        flex: 1,
        flexDirection: 'row',
    },
    sideMenu: {
        width: '15%',
        backgroundColor: colors.card,
        paddingVertical: 20,
        paddingHorizontal: 10,
        borderRightWidth: 1,
        borderRightColor: colors.border,
    },
    selectedButton: {
        margin: 10,
        borderRadius: 5,
        borderWidth: 2,
        elevation: 5,
        shadowColor: colors.card_line,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.3,
        shadowRadius: 5,
        backgroundColor: colors.background_card,
        borderColor: colors.buttons_submit,
    },
    cardStyleServiceLine: {
        margin: 10,
        borderRadius: 5,
        elevation: 5,
        shadowColor: colors.card_line,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.3,
        shadowRadius: 5,
        backgroundColor: colors.background_card,
    },
    mainContent: {
        flex: 1,
        padding: 10,
    },
    totalCard: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: colors.background_card,
        elevation: 10,
        shadowColor: colors.card_line,
        shadowOffset: { width: 0, height: -2 },
        shadowOpacity: 0.3,
        shadowRadius: 5,
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
        paddingVertical: 10,
        paddingHorizontal: 5,
        zIndex: 1000,
    },
    horizontalLine: {
        backgroundColor: colors.buttons_primary,
        height: 1,
        width: '100%',
        marginVertical: 6,
    },
    tabButton: {
        paddingVertical: 3,
        paddingHorizontal: Math.min(Math.max(width * 0.01, 5), 16),
        marginRight: Math.min(Math.max(width * 0.01, 3), 8),
        borderRadius: 5,
        backgroundColor: colors.background_card,
        justifyContent: 'center',
        alignItems: 'center',
        elevation: 5,
        shadowColor: colors.card_line,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.3,
        shadowRadius: 5,
    },
    tabButtonSelected: {
        margin: Math.min(Math.max(width * 0.01, 5), 10),
        borderRadius: 5,
        borderWidth: 2,
        elevation: 5,
        shadowColor: colors.card_line,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.3,
        shadowRadius: 5,
        backgroundColor: colors.background_card,
        borderColor: colors.buttons_submit,
    },
    functionalityButtons: {
        justifyContent: 'flex-end',
    },
    buttons: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'flex-end',
        width: '50%',
        alignSelf: 'flex-end',
    },
    calendarOverlay: {
        position: 'absolute',
        top: '10%',
        left: '50%',
        transform: [{ translateX: -160 }],
        backgroundColor: 'white',
        borderRadius: 10,
        zIndex: 999,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.25,
        shadowRadius: 3.84,
        elevation: 5,
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'center',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 6 },
        shadowOpacity: 0.5,
        shadowRadius: 20,
        elevation: 15,
    },
    overlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        height: '400%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 998,
    },
    attachmentContainer: {
        flexDirection: 'row',
        borderRadius: 5,
        padding: 5,
        marginHorizontal: '2%',
        marginVertical: 5,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#f2f2f2'
    },
    attachmentsNotExistView: {
        flex: 1,
        borderColor: '#e8e8e8',
        borderWidth: 2,
        elevation: 5,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.3,
        shadowRadius: 5,
        shadowColor: colors.card_line,
        backgroundColor: colors.background_card,
        borderRadius: 10,
        padding: 5,
        margin: 10,
    },
    attachmentIcons: {
        width: 20,
        alignSelf: 'center',
        color: colors.text_primary,
    },
    attachmentNameContainer: {
        flex: 7,
        alignItems: 'flex-start',
        paddingHorizontal: 12,
    },
    attachmentNameText: {
        fontSize: 16,
        color: colors.text_primary,
        alignSelf: 'center',
    },
    dotsIcon: {
        fontSize: 21,
        color: colors.text_primary
    },
    attachmentList: {
        borderTopRadius: 3,
        borderTopWidth: 1,
        shadowTopColor: colors.card_line,
        shadowTopOffset: { width: 0, height: 0 },
        shadowTopOpacity: 0.2,
        shadowTopRadius: 2,
        backgroundColor: colors.background_card,
        borderTopColor: colors.buttons_submit,
    },
    centeredView: {
        justifyContent: 'center',
        alignItems: 'center',
        opacity: 1,
    },
    modalView: {
        margin: 20,
        backgroundColor: 'white',
        borderRadius: 20,
        padding: 35,
    },
    fullScreenModal: {
        width: '100%',
        height: '100%',
        borderRadius: 20,
        padding: 35,
        margin: 20,
    },
    mainDetails: {
        flex: 2,
        margin: 20,
    },
    main: {
        flex: 1,
        marginTop: 20,
    },
});
const optionsStyles = {
    optionsContainer: {
        marginHorizontal: '3.5%',
        marginVertical: '-3%',
        borderRadius: 10,
    },
    optionWrapper: {
        height: 50,
        justifyContent: 'center',
    },
};
const removeOptionStyles = {
    optionText: {
        textAlign: 'center',
        fontSize: 16,
        color: '#dd3636',
    },
};
const cancelOptionStyles = {
    optionText: {
        textAlign: 'center',
        fontSize: 16,
    },
};

export default MyTimesheetsDetailsScreen;